import React, { useState, useEffect ,useCallback } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RingLoader } from "react-spinners";
import { Card, CardHeader, CardBody, Row, Col, Button, Input, FormGroup, Label, Table, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import axios from 'axios';
import apiConfig from "../config/apiConfig";
// تابع debounce ساده
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};
function FoodList() {
  const [isLoading, setIsLoading] = useState(false);
  const [showGlobalLoading, setShowGlobalLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editMenuId, setEditMenuId] = useState(null);
  const [items, setItems] = useState([{ id: Date.now(), name: "", calories: "", percentage: "", rounding_method: "round_half" }]);
  const [foldNappes, setFoldNappes] = useState([]);
  const [filterOver100, setFilterOver100] = useState(false);
  const [formType, setFormType] = useState("menu"); // "menu" یا "portion"
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    meal: "",
    diet_type: "",
    portion_type: "",
    additionalCategories: [],
    additionalMeals: [],
    text: ""
  });
  const [copiedData, setCopiedData] = useState(null);
  const [menuList, setMenuList] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [filterCategory, setFilterCategory] = useState("");
  const [filterMeal, setFilterMeal] = useState("");
  const [filterWithoutGroup, setFilterWithoutGroup] = useState(false); // فیلتر برای نمایش فقط منوهای بدون گروه
  const [isFilteringWithoutGroup, setIsFilteringWithoutGroup] = useState(false); // برای نمایش loading روی دکمه فیلتر بدون گروه
  const [selectedFoldNappes, setSelectedFoldNappes] = useState({});
  const [isFoodSelected, setIsFoodSelected] = useState({});
  const [shouldGoToLastPage, setShouldGoToLastPage] = useState(false);
  const serverUrl = apiConfig.serverUrl;

// اضافه کردن state جدید برای مدیریت تخصیص گروه
const [showGroupModal, setShowGroupModal] = useState(null); // برای کنترل نمایش مدال تخصیص گروه
const [selectedGroup, setSelectedGroup] = useState(""); // برای ذخیره شماره گروه انتخاب‌شده
const [groupTitle, setGroupTitle] = useState(""); // برای ذخیره عنوان گروه
const [groupRepetitionCount, setGroupRepetitionCount] = useState(""); // برای ذخیره تعداد تکرار هفتگی

// State برای گروه‌بندی دسته‌ای
const [selectedMenusForBulkGroup, setSelectedMenusForBulkGroup] = useState([]); // لیست ID منوهای انتخاب شده برای گروه‌بندی دسته‌ای
const [selectedMenusData, setSelectedMenusData] = useState([]); // اطلاعات کامل منوهای انتخاب شده
const [showBulkGroupModal, setShowBulkGroupModal] = useState(false); // برای کنترل نمایش مدال گروه‌بندی دسته‌ای
const [bulkGroupNumber, setBulkGroupNumber] = useState(""); // شماره گروه برای گروه‌بندی دسته‌ای
const [bulkGroupTitle, setBulkGroupTitle] = useState(""); // عنوان گروه برای گروه‌بندی دسته‌ای
const [bulkGroupRepetitionCount, setBulkGroupRepetitionCount] = useState(""); // تکرار هفتگی برای گروه‌بندی دسته‌ای
const [existingGroups, setExistingGroups] = useState([]); // لیست گروه‌های موجود
const [isLoadingExistingGroups, setIsLoadingExistingGroups] = useState(false); // برای نمایش loading هنگام بارگذاری گروه‌های موجود

// State برای ریست گروه‌ها
const [showResetGroupsModal, setShowResetGroupsModal] = useState(false); // برای کنترل نمایش مدال ریست گروه‌ها
const [menusWithGroups, setMenusWithGroups] = useState([]); // لیست منوهایی که گروه دارند
const [isLoadingGroups, setIsLoadingGroups] = useState(false); // برای نمایش loading هنگام بارگذاری منوهای دارای گروه

// State برای مدیریت گروه‌ها
const [showManageGroupsModal, setShowManageGroupsModal] = useState(false); // برای کنترل نمایش مدال مدیریت گروه‌ها
const [groupsWithMenus, setGroupsWithMenus] = useState([]); // لیست گروه‌ها و منوهایشان
const [isLoadingGroupsList, setIsLoadingGroupsList] = useState(false); // برای نمایش loading هنگام بارگذاری گروه‌ها
const [expandedGroups, setExpandedGroups] = useState(new Set()); // برای track کردن گروه‌های expand شده
const [groupSearchQuery, setGroupSearchQuery] = useState(""); // برای جستجوی گروه‌ها
const [editingRepetitionCount, setEditingRepetitionCount] = useState({}); // برای ذخیره مقدار موقت تعداد تکرار هفتگی هر گروه
const [removingMenuIds, setRemovingMenuIds] = useState(new Set()); // برای track کردن منوهایی که در حال حذف هستند

// State برای نمایش منوهای بدون گروه
const [showMenusWithoutGroupModal, setShowMenusWithoutGroupModal] = useState(false); // برای کنترل نمایش مدال منوهای بدون گروه
const [menusWithoutGroup, setMenusWithoutGroup] = useState([]); // لیست منوهای بدون گروه
const [isLoadingMenusWithoutGroup, setIsLoadingMenusWithoutGroup] = useState(false); // برای نمایش loading هنگام بارگذاری منوهای بدون گروه
const [menusWithoutGroupSearchQuery, setMenusWithoutGroupSearchQuery] = useState(""); // برای جستجوی منوهای بدون گروه

// تابع برای ارسال گروه به سرور
const assignGroupToMenu = async (menuId, groupNumber, groupTitle, repetitionCount) => {
  try {
    await axios.post(`${serverUrl}assign-group`, {
      menuId,
      groupNumber,
      groupTitle, // اضافه کردن عنوان گروه به درخواست
      groupRepetitionCount: repetitionCount ? parseInt(repetitionCount) : null // ارسال تعداد تکرار (یا null)
    });
    const repetitionText = repetitionCount ? ` با ${repetitionCount} بار تکرار در هفته` : "";
    toast.success(`گروه ${groupNumber} با عنوان ${groupTitle}${repetitionText} با موفقیت تخصیص یافت!`, { position: "top-center" });
    fetchMenuList(pagination.current_page); // به‌روزرسانی لیست
  } catch (error) {
    toast.error("خطا در تخصیص گروه: " + (error.response?.data?.message || error.message), { position: "top-center" });
  }
};

// تابع برای دریافت گروه‌های موجود
const fetchExistingGroups = async () => {
  try {
    setIsLoadingExistingGroups(true);
    const response = await axios.get(`${serverUrl}get-groups-with-menus`);
    // API داده‌ها را به صورت گروه‌بندی شده برمی‌گرداند
    // هر گروه شامل: group_number, group_title, group_repetition_count, menus (آرایه)
    if (response.data.data && Array.isArray(response.data.data)) {
      const groups = response.data.data.map(group => ({
        group_number: group.group_number,
        group_title: group.group_title,
        group_repetition_count: group.group_repetition_count || null,
        menu_count: group.menus ? group.menus.length : 0
      }));
      setExistingGroups(groups);
    } else {
      setExistingGroups([]);
    }
  } catch (error) {
    console.error("خطا در دریافت گروه‌های موجود:", error);
    toast.error("خطا در دریافت گروه‌های موجود: " + (error.response?.data?.message || error.message), { position: "top-center" });
    setExistingGroups([]);
  } finally {
    setIsLoadingExistingGroups(false);
  }
};

// تابع برای تخصیص منوها به یک گروه موجود
const assignMenusToExistingGroup = async (groupNumber, groupTitle, groupRepetitionCount) => {
  if (selectedMenusForBulkGroup.length === 0) {
    toast.warning("لطفاً حداقل یک منو را انتخاب کنید", { position: "top-center" });
    return;
  }

  try {
    setIsLoading(true);
    // ارسال درخواست برای تخصیص به گروه موجود
    await axios.post(`${serverUrl}assign-group-bulk`, {
      menuIds: selectedMenusForBulkGroup,
      groupNumber: groupNumber,
      groupTitle: groupTitle,
      groupRepetitionCount: groupRepetitionCount ? parseInt(groupRepetitionCount) : null
    });
    
    const repetitionText = groupRepetitionCount ? ` با ${groupRepetitionCount} بار تکرار در هفته` : "";
    toast.success(`${selectedMenusForBulkGroup.length} منو با موفقیت به گروه ${groupNumber} (${groupTitle})${repetitionText} اختصاص یافت!`, { position: "top-center" });
    
    // پاک کردن انتخاب‌ها و بستن مدال
    setSelectedMenusForBulkGroup([]);
    setSelectedMenusData([]);
    setShowBulkGroupModal(false);
    setBulkGroupNumber("");
    setBulkGroupTitle("");
    setBulkGroupRepetitionCount("");
    
    fetchMenuList(pagination.current_page); // به‌روزرسانی لیست
    fetchExistingGroups(); // به‌روزرسانی لیست گروه‌های موجود
  } catch (error) {
    toast.error("خطا در تخصیص به گروه موجود: " + (error.response?.data?.message || error.message), { position: "top-center" });
  } finally {
    setIsLoading(false);
  }
};

// تابع برای انتخاب (تیک زدن) منو در مودال گروه‌بندی دسته‌ای
const handleSelectFoodInBulkModal = async (menuId, menuName) => {
  try {
    setIsLoading(true);
    // ارسال درخواست برای تیک زدن انتخاب غذا
    await axios.post(`${serverUrl}update-selection`, {
      type: "food",
      value: menuName, // استفاده از نام منو به عنوان مقدار
      menuId: menuId
    });
    
    // به‌روزرسانی selectedMenusData
    setSelectedMenusData(prev => prev.map(menu => 
      menu.id === menuId 
        ? { ...menu, selected_food: menuName }
        : menu
    ));
    
    // به‌روزرسانی isFoodSelected
    setIsFoodSelected(prev => ({ ...prev, [menuId]: true }));
    
    toast.success(`منو "${menuName}" انتخاب شد`, { position: "top-center" });
    
    // به‌روزرسانی لیست منوها برای اطمینان از همگام بودن
    await fetchSelectedMenusData();
  } catch (error) {
    toast.error("خطا در انتخاب منو: " + (error.response?.data?.message || error.message), { position: "top-center" });
  } finally {
    setIsLoading(false);
  }
};

// تابع برای حذف منو از لیست انتخاب شده در مودال گروه‌بندی دسته‌ای
const handleRemoveMenuFromBulkSelection = (menuId) => {
  setSelectedMenusForBulkGroup(prev => prev.filter(id => id !== menuId));
  setSelectedMenusData(prev => prev.filter(menu => menu.id !== menuId));
  toast.info("منو از لیست انتخاب شده حذف شد", { position: "top-center" });
};

// تابع برای انتخاب همگی منوهای بدون تیک
const handleSelectAllUnselectedMenus = async () => {
  const unselectedMenus = selectedMenusData.filter(menu => 
    !menu.selected_food || 
    menu.selected_food === null || 
    menu.selected_food === undefined ||
    (typeof menu.selected_food === "string" && menu.selected_food.trim().length === 0)
  );
  
  if (unselectedMenus.length === 0) {
    toast.info("همه منوها قبلاً انتخاب شده‌اند", { position: "top-center" });
    return;
  }
  
  try {
    setIsLoading(true);
    // ارسال درخواست برای تیک زدن همه منوها
    const promises = unselectedMenus.map(menu => 
      axios.post(`${serverUrl}update-selection`, {
        type: "food",
        value: menu.name,
        menuId: menu.id
      })
    );
    
    await Promise.all(promises);
    
    // به‌روزرسانی selectedMenusData
    setSelectedMenusData(prev => prev.map(menu => {
      const unselectedMenu = unselectedMenus.find(m => m.id === menu.id);
      if (unselectedMenu) {
        return { ...menu, selected_food: menu.name };
      }
      return menu;
    }));
    
    // به‌روزرسانی isFoodSelected
    const newIsFoodSelected = { ...isFoodSelected };
    unselectedMenus.forEach(menu => {
      newIsFoodSelected[menu.id] = true;
    });
    setIsFoodSelected(newIsFoodSelected);
    
    toast.success(`${unselectedMenus.length} منو با موفقیت انتخاب شدند`, { position: "top-center" });
    
    // به‌روزرسانی لیست منوها
    await fetchSelectedMenusData();
  } catch (error) {
    toast.error("خطا در انتخاب منوها: " + (error.response?.data?.message || error.message), { position: "top-center" });
  } finally {
    setIsLoading(false);
  }
};

// تابع برای حذف همگی منوهای بدون تیک از لیست انتخاب شده
const handleRemoveAllUnselectedMenus = () => {
  const unselectedMenus = selectedMenusData.filter(menu => 
    !menu.selected_food || 
    menu.selected_food === null || 
    menu.selected_food === undefined ||
    (typeof menu.selected_food === "string" && menu.selected_food.trim().length === 0)
  );
  
  if (unselectedMenus.length === 0) {
    toast.info("همه منوها انتخاب شده‌اند", { position: "top-center" });
    return;
  }
  
  const unselectedIds = unselectedMenus.map(menu => menu.id);
  setSelectedMenusForBulkGroup(prev => prev.filter(id => !unselectedIds.includes(id)));
  setSelectedMenusData(prev => prev.filter(menu => !unselectedIds.includes(menu.id)));
  toast.info(`${unselectedMenus.length} منو از لیست انتخاب شده حذف شدند`, { position: "top-center" });
};

// تابع برای گروه‌بندی دسته‌ای
const handleBulkGroupAssignment = async () => {
  if (selectedMenusForBulkGroup.length === 0) {
    toast.warning("لطفاً حداقل یک منو را انتخاب کنید", { position: "top-center" });
    return;
  }
  if (bulkGroupNumber === "" || bulkGroupTitle === "") {
    toast.warning("لطفاً شماره و عنوان گروه را وارد کنید", { position: "top-center" });
    return;
  }

  try {
    setIsLoading(true);
    // ارسال درخواست برای گروه‌بندی دسته‌ای
    await axios.post(`${serverUrl}assign-group-bulk`, {
      menuIds: selectedMenusForBulkGroup,
      groupNumber: bulkGroupNumber,
      groupTitle: bulkGroupTitle,
      groupRepetitionCount: bulkGroupRepetitionCount ? parseInt(bulkGroupRepetitionCount) : null
    });
    
    const repetitionText = bulkGroupRepetitionCount ? ` با ${bulkGroupRepetitionCount} بار تکرار در هفته` : "";
    toast.success(`${selectedMenusForBulkGroup.length} منو با موفقیت به گروه ${bulkGroupNumber} (${bulkGroupTitle})${repetitionText} اختصاص یافت!`, { position: "top-center" });
    
    // پاک کردن انتخاب‌ها و بستن مدال
    setSelectedMenusForBulkGroup([]);
    setSelectedMenusData([]);
    setShowBulkGroupModal(false);
    setBulkGroupNumber("");
    setBulkGroupTitle("");
    setBulkGroupRepetitionCount("");
    
    fetchMenuList(pagination.current_page); // به‌روزرسانی لیست
    fetchExistingGroups(); // به‌روزرسانی لیست گروه‌های موجود
  } catch (error) {
    toast.error("خطا در گروه‌بندی دسته‌ای: " + (error.response?.data?.message || error.message), { position: "top-center" });
  } finally {
    setIsLoading(false);
  }
};

// تابع برای انتخاب/لغو انتخاب یک منو
const handleMenuSelection = (menuId) => {
  setSelectedMenusForBulkGroup(prev => {
    if (prev.includes(menuId)) {
      // حذف از لیست انتخاب شده
      setSelectedMenusData(prevData => prevData.filter(menu => menu.id !== menuId));
      return prev.filter(id => id !== menuId);
    } else {
      // اضافه کردن به لیست انتخاب شده
      const menu = menuList.find(m => m.id === menuId);
      if (menu) {
        setSelectedMenusData(prevData => {
          // بررسی اینکه آیا قبلاً اضافه نشده
          if (!prevData.find(m => m.id === menuId)) {
            return [...prevData, {
              id: menu.id,
              name: menu.name || "",
              category: menu.category || "",
              meal: menu.meal || "",
              text: menu.text || ""
            }];
          }
          return prevData;
        });
      }
      return [...prev, menuId];
    }
  });
};

// تابع برای دریافت اطلاعات کامل منوهای انتخاب شده
const fetchSelectedMenusData = async () => {
  if (selectedMenusForBulkGroup.length === 0) {
    setSelectedMenusData([]);
    return;
  }

  try {
    const allMenusData = [];
    let currentPage = 1;
    let hasMorePages = true;
    const foundIds = new Set();

    // دریافت تمام صفحات برای پیدا کردن منوهای انتخاب شده
    while (hasMorePages && foundIds.size < selectedMenusForBulkGroup.length) {
      const response = await axios.get(serverUrl + 'get-food-list', {
        params: { 
          page: currentPage, 
          search: searchQuery, 
          category: filterCategory, 
          meal: filterMeal,
          over_100: filterOver100 ? 1 : 0,
          per_page: 100
        }
      });

      // فیلتر کردن منوهای انتخاب شده
      const selectedMenus = response.data.data.filter(menu => 
        selectedMenusForBulkGroup.includes(menu.id) && !foundIds.has(menu.id)
      );

      // فرمت کردن داده‌ها
      selectedMenus.forEach(menu => {
        foundIds.add(menu.id);
        allMenusData.push({
          id: menu.id,
          name: menu.name || "",
          category: menu.category || "",
          meal: menu.meal || "",
          text: menu.text || "",
          selected_food: menu.selected_food || null
        });
      });

      // بررسی اینکه آیا صفحه بعدی وجود دارد
      const totalPages = response.data.pagination?.last_page || 1;
      if (currentPage >= totalPages || foundIds.size >= selectedMenusForBulkGroup.length) {
        hasMorePages = false;
      } else {
        currentPage++;
      }
    }

    setSelectedMenusData(allMenusData);
  } catch (error) {
    console.error("خطا در دریافت اطلاعات منوها:", error);
    toast.error("خطا در دریافت اطلاعات منوها", { position: "top-center" });
  }
};

// تابع برای انتخاب/لغو انتخاب همه منوهای جستجو شده (تمام صفحات)
const handleSelectAll = async () => {
  // همیشه تمام نتایج جستجو/فیلتر را انتخاب کن (حتی اگر جستجو فعال نباشد، تمام منوها)
  const allIds = await fetchAllSearchResultIds(true);
  if (allIds.length > 0) {
    // بررسی اینکه آیا همه نتایج قبلاً انتخاب شده‌اند
    const allSelected = allIds.every(id => selectedMenusForBulkGroup.includes(id));
    
    if (allSelected) {
      // اگر همه انتخاب شده‌اند، همه را لغو انتخاب کن
      setSelectedMenusForBulkGroup(prev => prev.filter(id => !allIds.includes(id)));
      toast.info("انتخاب همه نتایج لغو شد", { position: "top-center" });
    } else {
      // همه نتایج را انتخاب کن
      setSelectedMenusForBulkGroup(allIds);
      toast.success(`${allIds.length} منو از تمام نتایج انتخاب شد`, { position: "top-center" });
    }
  }
};

// تابع برای دریافت تمام ID های منوهای جستجو شده (تمام صفحات)
const fetchAllSearchResultIds = async (showLoading = false) => {
  try {
    if (showLoading) setIsLoading(true);
    const allMenus = [];
    let currentPage = 1;
    let hasMorePages = true;

    // دریافت تمام صفحات
    while (hasMorePages) {
      const response = await axios.get(serverUrl + 'get-food-list', {
        params: { 
          page: currentPage, 
          search: searchQuery, 
          category: filterCategory, 
          meal: filterMeal,
          over_100: filterOver100 ? 1 : 0,
          per_page: 100 // تعداد بیشتر برای کاهش تعداد درخواست‌ها
        }
      });

      // ذخیره کل منوها (نه فقط ID) برای اعمال فیلتر "بدون گروه"
      allMenus.push(...response.data.data);

      // بررسی اینکه آیا صفحه بعدی وجود دارد
      const totalPages = response.data.pagination?.last_page || 1;
      if (currentPage >= totalPages) {
        hasMorePages = false;
      } else {
        currentPage++;
      }
    }

    // اعمال فیلتر "بدون گروه" در صورت فعال بودن
    let filteredMenus = allMenus;
    if (filterWithoutGroup) {
      filteredMenus = allMenus.filter(menu => !menu.group_number && !menu.group_title);
    }

    // استخراج فقط ID ها از منوهای فیلتر شده
    const allIds = filteredMenus.map(menu => menu.id);

    return allIds;
  } catch (error) {
    console.error("خطا در دریافت تمام نتایج:", error);
    toast.error("خطا در دریافت تمام نتایج جستجو: " + (error.response?.data?.message || error.message), { position: "top-center" });
    return [];
  } finally {
    if (showLoading) setIsLoading(false);
  }
};

// تابع برای انتخاب تمام نتایج جستجو
const handleSelectAllSearchResults = async () => {
  const allIds = await fetchAllSearchResultIds(true);
  if (allIds.length > 0) {
    setSelectedMenusForBulkGroup(allIds);
    toast.success(`${allIds.length} منو از تمام نتایج جستجو انتخاب شد`, { position: "top-center" });
  } else {
    toast.warning("هیچ نتیجه‌ای یافت نشد", { position: "top-center" });
  }
};

// تابع برای دریافت منوهایی که گروه دارند
const fetchMenusWithGroups = async () => {
  try {
    setIsLoadingGroups(true);
    const response = await axios.get(`${serverUrl}get-menus-with-groups`);
    setMenusWithGroups(response.data.data || []);
  } catch (error) {
    console.error("خطا در دریافت منوهای دارای گروه:", error);
    toast.error("خطا در دریافت منوهای دارای گروه: " + (error.response?.data?.message || error.message), { position: "top-center" });
    setMenusWithGroups([]);
  } finally {
    setIsLoadingGroups(false);
  }
};

// تابع برای ریست کردن همه گروه‌ها
const handleResetAllGroups = async () => {
  try {
    setIsLoading(true);
    const response = await axios.post(`${serverUrl}reset-all-groups`);
    toast.success(response.data.message || "تمام گروه‌ها با موفقیت ریست شدند", { position: "top-center" });
    setShowResetGroupsModal(false);
    setMenusWithGroups([]);
    fetchMenuList(pagination.current_page); // به‌روزرسانی لیست
  } catch (error) {
    toast.error("خطا در ریست گروه‌ها: " + (error.response?.data?.message || error.message), { position: "top-center" });
  } finally {
    setIsLoading(false);
  }
};

// تابع برای دریافت لیست گروه‌ها و منوهایشان
const fetchGroupsWithMenus = async (resetExpanded = true) => {
  try {
    setIsLoadingGroupsList(true);
    const response = await axios.get(`${serverUrl}get-groups-with-menus`);
    setGroupsWithMenus(response.data.data || []);
    if (resetExpanded) {
      setExpandedGroups(new Set()); // ریست کردن expand ها فقط در صورت نیاز
    }
  } catch (error) {
    console.error("خطا در دریافت گروه‌ها:", error);
    toast.error("خطا در دریافت گروه‌ها: " + (error.response?.data?.message || error.message), { position: "top-center" });
    setGroupsWithMenus([]);
  } finally {
    setIsLoadingGroupsList(false);
  }
};

// تابع برای toggle کردن expand یک گروه
const toggleGroupExpand = (groupKey) => {
  setExpandedGroups(prev => {
    const newSet = new Set(prev);
    if (newSet.has(groupKey)) {
      newSet.delete(groupKey);
    } else {
      newSet.add(groupKey);
    }
    return newSet;
  });
};

// تابع برای دریافت منوهای بدون گروه
const fetchMenusWithoutGroup = async () => {
  try {
    setIsLoadingMenusWithoutGroup(true);
    // دریافت تمام منوهایی که group_number یا group_title ندارند
    const response = await axios.get(`${serverUrl}get-food-list`, {
      params: {
        page: 1,
        per_page: 1000, // تعداد زیاد برای دریافت همه منوها
        without_group: 1 // پارامتر برای فیلتر منوهای بدون گروه
      }
    });
    
    // اگر API پارامتر without_group را پشتیبانی نمی‌کند، باید از سمت کلاینت فیلتر کنیم
    let menus = response.data.data || [];
    if (!response.data.data || response.data.data.length === 0 || menus.some(m => m.group_number || m.group_title)) {
      // اگر API پارامتر without_group را پشتیبانی نمی‌کند، همه صفحات را دریافت و فیلتر کنیم
      menus = [];
      let currentPage = 1;
      let hasMorePages = true;
      
      while (hasMorePages) {
        const pageResponse = await axios.get(`${serverUrl}get-food-list`, {
          params: {
            page: currentPage,
            per_page: 100
          }
        });
        
        const pageMenus = pageResponse.data.data || [];
        const menusWithoutGroup = pageMenus.filter(menu => 
          !menu.group_number && !menu.group_title
        );
        menus.push(...menusWithoutGroup);
        
        const totalPages = pageResponse.data.pagination?.last_page || 1;
        if (currentPage >= totalPages) {
          hasMorePages = false;
        } else {
          currentPage++;
        }
      }
    }
    
    setMenusWithoutGroup(menus);
  } catch (error) {
    console.error("خطا در دریافت منوهای بدون گروه:", error);
    toast.error("خطا در دریافت منوهای بدون گروه: " + (error.response?.data?.message || error.message), { position: "top-center" });
    setMenusWithoutGroup([]);
  } finally {
    setIsLoadingMenusWithoutGroup(false);
  }
};

// تابع برای به‌روزرسانی تعداد تکرار هفتگی یک گروه
const updateGroupRepetitionCount = async (groupNumber, groupTitle, newRepetitionCount) => {
  try {
    setIsLoading(true);
    
    // پیدا کردن تمام منوهای این گروه
    const group = groupsWithMenus.find(g => 
      g.group_number === groupNumber && g.group_title === groupTitle
    );
    
    if (!group || !group.menus || group.menus.length === 0) {
      toast.warning("گروه پیدا نشد یا منویی ندارد", { position: "top-center" });
      return;
    }
    
    const menuIds = group.menus.map(menu => menu.id);
    const repetitionCount = newRepetitionCount === "" || newRepetitionCount === null 
      ? null 
      : parseInt(newRepetitionCount);
    
    // اعتبارسنجی مقدار
    if (repetitionCount !== null && (repetitionCount < 1 || repetitionCount > 7)) {
      toast.error("تعداد تکرار باید بین 1 تا 7 باشد", { position: "top-center" });
      return;
    }
    
    // ارسال درخواست برای به‌روزرسانی
    await axios.post(`${serverUrl}assign-group-bulk`, {
      menuIds: menuIds,
      groupNumber: groupNumber,
      groupTitle: groupTitle,
      groupRepetitionCount: repetitionCount
    });
    
    const repetitionText = repetitionCount ? ` با ${repetitionCount} بار تکرار در هفته` : " بدون محدودیت تکرار";
    toast.success(`تعداد تکرار هفتگی گروه ${groupNumber} (${groupTitle})${repetitionText} به‌روزرسانی شد!`, { position: "top-center" });
    
    // به‌روزرسانی لیست گروه‌ها
    await fetchGroupsWithMenus();
    fetchMenuList(pagination.current_page); // به‌روزرسانی لیست منوها
    
    // پاک کردن مقدار موقت
    const groupKey = `${groupNumber}_${groupTitle}`;
    setEditingRepetitionCount(prev => {
      const newState = { ...prev };
      delete newState[groupKey];
      return newState;
    });
  } catch (error) {
    toast.error("خطا در به‌روزرسانی تعداد تکرار: " + (error.response?.data?.message || error.message), { position: "top-center" });
  } finally {
    setIsLoading(false);
  }
};

// تابع برای حذف منو از گروه
const handleRemoveMenuFromGroup = async (menuId) => {
  // پیدا کردن منو و گروه مربوطه برای rollback در صورت خطا
  let menuToRestore = null;
  let groupKeyToRestore = null;
  
  groupsWithMenus.forEach(group => {
    const menu = group.menus?.find(m => m.id === menuId);
    if (menu) {
      menuToRestore = menu;
      groupKeyToRestore = `${group.group_number}_${group.group_title}`;
    }
  });
  
  // Optimistic update: فوراً منو را از UI حذف می‌کنیم
  setGroupsWithMenus(prevGroups => {
    return prevGroups.map(group => {
      const updatedMenus = group.menus?.filter(menu => menu.id !== menuId) || [];
      if (updatedMenus.length !== group.menus?.length) {
        // اگر منویی حذف شد، گروه را به‌روزرسانی کن
        return {
          ...group,
          menus: updatedMenus
        };
      }
      return group;
    });
  });
  
  // ارسال درخواست به API در پس‌زمینه (بدون نمایش loading)
  axios.post(`${serverUrl}remove-menu-from-group`, {
    menuId: menuId
  })
  .then((response) => {
    toast.success(response.data.message || "منو با موفقیت از گروه خارج شد", { position: "top-center" });
    // به‌روزرسانی لیست منوها در پس‌زمینه بدون نمایش loading
    fetchMenuList(pagination.current_page, true);
  })
  .catch((error) => {
    console.error("خطا در حذف منو از گروه:", error);
    
    // Rollback: برگرداندن منو در صورت خطا
    if (menuToRestore && groupKeyToRestore) {
      setGroupsWithMenus(prevGroups => {
        return prevGroups.map(group => {
          const groupKey = `${group.group_number}_${group.group_title}`;
          if (groupKey === groupKeyToRestore) {
            // بررسی اینکه آیا منو قبلاً وجود نداشته (برای جلوگیری از duplicate)
            const menuExists = group.menus?.some(m => m.id === menuId);
            if (!menuExists) {
              return {
                ...group,
                menus: [...(group.menus || []), menuToRestore]
              };
            }
          }
          return group;
        });
      });
    }
    
    toast.error("خطا در حذف منو از گروه: " + (error.response?.data?.message || error.message), { position: "top-center" });
  });
};

// تابع برای حذف کلی گروه
const handleDeleteGroup = async (groupNumber, groupTitle) => {
  if (!window.confirm(`آیا از حذف گروه ${groupNumber} (${groupTitle}) اطمینان دارید؟ تمام منوهای این گروه از گروه خارج می‌شوند.`)) {
    return;
  }
  
  try {
    setIsLoading(true);
    const response = await axios.post(`${serverUrl}delete-group`, {
      groupNumber: groupNumber,
      groupTitle: groupTitle
    });
    toast.success(response.data.message || "گروه با موفقیت حذف شد", { position: "top-center" });
    await fetchGroupsWithMenus(); // به‌روزرسانی لیست گروه‌ها
    fetchMenuList(pagination.current_page); // به‌روزرسانی لیست منوها
  } catch (error) {
    console.error("خطا در حذف گروه:", error);
    toast.error("خطا در حذف گروه: " + (error.response?.data?.message || error.message), { position: "top-center" });
  } finally {
    setIsLoading(false);
  }
};


// استایل برای مدال تخصیص گروه
const groupModalStyle = {
  background: "#f8fafc",
  borderRadius: "12px",
  border: "1px solid rgba(203, 213, 225, 0.5)",
  color: "#1f2937",
  fontFamily: "'Dana', sans-serif",
  maxWidth: "350px",
  width: "100%",
  margin: "auto",
  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)"
};

// استایل برای دکمه‌های شماره
const numberButtonStyle = {
  background: "linear-gradient(45deg, #e2e8f0, #f1f5f9)",
  border: "1px solid #cbd5e1",
  borderRadius: "8px",
  padding: "12px",
  color: "#1f2937",
  fontSize: "1rem",
  fontFamily: "'Dana', sans-serif",
  cursor: "pointer",
  width: "48px",
  height: "48px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "6px",
  transition: "all 0.2s ease"
};

const numberButtonHoverStyle = {
  background: "linear-gradient(45deg, #d1d5db, #e5e7eb)",
  transform: "translateY(-2px)",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
};

const numberButtonActiveStyle = {
  background: "linear-gradient(45deg, #a5b4fc, #c7d2fe)",
  color: "#1e40af",
  fontWeight: "600",
  border: "1px solid #818cf8"
};

// استایل برای ورودی متنی
const groupInputStyle = {
  borderRadius: "8px",
  border: "1px solid #cbd5e1",
  padding: "10px",
  width: "100%",
  background: "#ffffff",
  color: "#1f2937",
  fontSize: "1rem",
  fontFamily: "'Dana', sans-serif",
  transition: "border-color 0.2s ease",
  marginBottom: "16px",
  textAlign: "center"
};



  // تابع برای جستجوی آیتم‌ها یا سفره‌چین‌ها در دیتابیس بر اساس نام
  const fetchItemOrFoldNappeByName = async (name, type) => {
    try {
      const response = await axios.get(`${serverUrl}search-item-or-fold-nappe`, {
        params: { name, type } // type می‌تونه "item" یا "fold_nappe" باشه
      });
      return response.data; // فرض می‌کنیم سرور داده‌های مرتبط (کالری، نحوه چیدمان و غیره) رو برمی‌گردونه
    } catch (error) {
      console.error(`خطا در جستجوی ${type}:`, error);
      return null;
    }
  };

  const fetchMenuList = async (page = 1, isFilterOrSearch = false, withoutGroupFilter = null) => {
    if (!isFilterOrSearch) setShowGlobalLoading(true);
    setIsLoading(true);
    try {
      // استفاده از پارامتر withoutGroupFilter اگر ارسال شده، در غیر این صورت از state
      const shouldFilterWithoutGroup = withoutGroupFilter !== null ? withoutGroupFilter : filterWithoutGroup;
      
      // اگر فیلتر "بدون گروه" فعال است، باید همه صفحات را دریافت کنیم
      let allMenusData = [];
      let paginationData = null;
      let totalPages = 1;
      let perPage = 10;
      
      if (shouldFilterWithoutGroup) {
        // دریافت صفحه اول برای اطلاع از تعداد کل صفحات
        const firstPageResponse = await axios.get(serverUrl + 'get-food-list', {
          params: { 
            page: 1, 
            search: searchQuery, 
            category: filterCategory, 
            meal: filterMeal,
            over_100: filterOver100 ? 1 : 0,
            per_page: 500 // تعداد بیشتر برای کاهش درخواست‌ها
          }
        });
        
        allMenusData.push(...firstPageResponse.data.data);
        paginationData = firstPageResponse.data.pagination;
        totalPages = firstPageResponse.data.pagination?.last_page || 1;
        perPage = firstPageResponse.data.pagination?.per_page || 10;
        
        // اگر صفحات بیشتری وجود دارد، به صورت موازی دریافت کن
        if (totalPages > 1) {
          const pagePromises = [];
          for (let page = 2; page <= totalPages; page++) {
            pagePromises.push(
              axios.get(serverUrl + 'get-food-list', {
                params: { 
                  page, 
                  search: searchQuery, 
                  category: filterCategory, 
                  meal: filterMeal,
                  over_100: filterOver100 ? 1 : 0,
                  per_page: 500
                }
              })
            );
          }
          
          // دریافت موازی همه صفحات
          const pageResponses = await Promise.all(pagePromises);
          pageResponses.forEach(response => {
            allMenusData.push(...response.data.data);
          });
        }
      } else {
        // دریافت فقط صفحه فعلی
        const response = await axios.get(serverUrl + 'get-food-list', {
          params: { page, search: searchQuery, category: filterCategory, meal: filterMeal ,over_100: filterOver100 ? 1 : 0}
        });
        allMenusData = response.data.data;
        paginationData = response.data.pagination;
        totalPages = response.data.pagination?.last_page || 1;
        perPage = response.data.pagination?.per_page || 10;
      }
      
      const formattedData = allMenusData.map((menu) => ({
        id: menu.id,
        name: menu.name || "",
        items: [
          menu.item1 && {
            name: menu.item1,
            calories: menu.calories_item1,
            percentage: menu.percentage_item1,
            rounding_method: menu.rounding_method_item1,
          },
          menu.item2 && {
            name: menu.item2,
            calories: menu.calories_item2,
            percentage: menu.percentage_item2,
            rounding_method: menu.rounding_method_item2,
          },
          menu.item3 && {
            name: menu.item3,
            calories: menu.calories_item3,
            percentage: menu.percentage_item3,
            rounding_method: menu.rounding_method_item3,
          },
          menu.item4 && {
            name: menu.item4,
            calories: menu.calories_item4,
            percentage: menu.percentage_item4,
            rounding_method: menu.rounding_method_item4,
          },
          menu.item5 && {
            name: menu.item5,
            calories: menu.calories_item5,
            percentage: menu.percentage_item5,
            rounding_method: menu.rounding_method_item5,
          },
        ].filter(Boolean),
        fold_nappes: [
          menu.fold_nappe1 && {
            name: menu.fold_nappe1,
            arrangement: menu.arrangement_fold_nappe1,
            percentage: menu.percentage_fold_nappe1,
            calories: menu.calories_fold_nappe1,
            rounding_method: menu.rounding_method_fold_nappe1 || "round_half",
          },
          menu.fold_nappe2 && {
            name: menu.fold_nappe2,
            arrangement: menu.arrangement_fold_nappe2,
            percentage: menu.percentage_fold_nappe2,
            calories: menu.calories_fold_nappe2,
            rounding_method: menu.rounding_method_fold_nappe2 || "round_half",
          },
          menu.fold_nappe3 && {
            name: menu.fold_nappe3,
            arrangement: menu.arrangement_fold_nappe3,
            percentage: menu.percentage_fold_nappe3,
            calories: menu.calories_fold_nappe3,
            rounding_method: menu.rounding_method_fold_nappe3 || "round_half",
          },
          menu.fold_nappe4 && {
            name: menu.fold_nappe4,
            arrangement: menu.arrangement_fold_nappe4,
            percentage: menu.percentage_fold_nappe4,
            calories: menu.calories_fold_nappe4,
            rounding_method: menu.rounding_method_fold_nappe4 || "round_half",
          },
          menu.fold_nappe5 && {
            name: menu.fold_nappe5,
            arrangement: menu.arrangement_fold_nappe5,
            percentage: menu.percentage_fold_nappe5,
            calories: menu.calories_fold_nappe5,
            rounding_method: menu.rounding_method_fold_nappe5 || "round_half",
          },
        ].filter(Boolean),
        category: menu.category || "",
        meal: menu.meal || "",
        diet_type: menu.diet_type || "",
        portion_type: menu.portion_type || "",
        text: menu.text || "",
        selected_food: menu.selected_food || null,
        selected_fold_nappe: menu.selected_fold_nappe || null,
        form_type: menu.form_type || "menu", // اضافه کردن form_type
        group_number : menu.group_number || null,
        group_title : menu.group_title || null,
        group_repetition_count : menu.group_repetition_count || null
      }));
      
      // اعمال فیلتر "بدون گروه" در صورت فعال بودن
      let filteredData = formattedData;
      if (shouldFilterWithoutGroup) {
        filteredData = formattedData.filter(menu => !menu.group_number && !menu.group_title);
        
        // محاسبه pagination دستی برای منوهای فیلتر شده
        const totalFiltered = filteredData.length;
        const perPageValue = perPage;
        const totalPagesFiltered = Math.ceil(totalFiltered / perPageValue);
        const startIndex = (page - 1) * perPageValue;
        const endIndex = startIndex + perPageValue;
        const paginatedData = filteredData.slice(startIndex, endIndex);
        
        setMenuList(paginatedData);
        setPagination({
          current_page: page,
          last_page: totalPagesFiltered || 1,
          per_page: perPageValue,
          total: totalFiltered
        });
      } else {
        setMenuList(filteredData);
        // pagination از API می‌آید
        if (paginationData) {
          setPagination(paginationData);
        }
      }

      const newIsFoodSelected = {};
      const newSelectedFoldNappes = {};
      // استفاده از داده‌های فیلتر شده برای تنظیم state
      const dataToProcess = shouldFilterWithoutGroup ? filteredData : formattedData;
      dataToProcess.forEach(menu => {
        newIsFoodSelected[menu.id] = !!menu.selected_food;
        if (menu.selected_fold_nappe) {
          newSelectedFoldNappes[menu.id] = menu.selected_fold_nappe;
        }
      });
      setIsFoodSelected(newIsFoodSelected);
      setSelectedFoldNappes(newSelectedFoldNappes);
    } catch (error) {
      toast.error("خطا در دریافت لیست منوها: " + (error.response?.data?.message || error.message), { position: "top-center" });
    } finally {
      setIsLoading(false);
      if (!isFilterOrSearch) setShowGlobalLoading(false);
    }
  };

  useEffect(() => {
    if (shouldGoToLastPage) {
      fetchMenuList(pagination.last_page, true);
    } else {
      fetchMenuList(1, true);
    }
  }, [searchQuery, filterCategory, filterMeal, shouldGoToLastPage , filterOver100]);

  // بارگذاری اطلاعات منوهای انتخاب شده وقتی مدال باز می‌شود
  useEffect(() => {
    if (showBulkGroupModal && selectedMenusForBulkGroup.length > 0) {
      fetchSelectedMenusData();
    } else if (!showBulkGroupModal) {
      setSelectedMenusData([]);
    }
  }, [showBulkGroupModal, selectedMenusForBulkGroup.length]);

  // بارگذاری گروه‌های موجود وقتی مدال باز می‌شود
  useEffect(() => {
    if (showBulkGroupModal) {
      fetchExistingGroups();
    }
  }, [showBulkGroupModal]);

  const sendSelectionToServer = async (type, value, menuId) => {
    try {
      await axios.post(`${serverUrl}update-selection`, {
        type,
        value,
        menuId
      });
      toast.success("با موفقیت انجام شد!", { position: "top-center" });
    } catch (error) {
      toast.error("خطا در ارسال انتخاب به سرور: " + (error.response?.data?.message || error.message), { position: "top-center" });
    }
  };

  const handleFoldNappeSelection = (menuId, foldNappeName) => {
    const newSelectedFoldNappes = { ...selectedFoldNappes };
    if (newSelectedFoldNappes[menuId] === foldNappeName) {
      delete newSelectedFoldNappes[menuId];
    } else {
      newSelectedFoldNappes[menuId] = foldNappeName;
    }
    setSelectedFoldNappes(newSelectedFoldNappes);
    sendSelectionToServer("fold_nappe", newSelectedFoldNappes[menuId] || null, menuId);
  };

  const handleFoodSelection = (menuId, foodName) => {
    const newIsFoodSelected = {
      ...isFoodSelected,
      [menuId]: !isFoodSelected[menuId]
    };
    setIsFoodSelected(newIsFoodSelected);
    sendSelectionToServer("food", newIsFoodSelected[menuId] ? foodName : null, menuId);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= pagination.last_page) {
      setPagination({ ...pagination, current_page: page });
      fetchMenuList(page);
    }
  };
   // تابع جدید برای رندر صفحه‌بندی بهینه
   const renderPagination = () => {
    const { current_page, last_page } = pagination;
    const maxButtons = 5; // حداکثر تعداد دکمه‌های قابل نمایش (بدون احتساب اولین/آخرین و نقاط)
    const buttons = [];
    
    // دکمه صفحه اول
    buttons.push({
      page: 1,
      label: "1",
      disabled: current_page === 1,
    });

    // محاسبه محدوده صفحات برای نمایش
    let startPage = Math.max(2, current_page - Math.floor(maxButtons / 2));
    let endPage = Math.min(last_page - 1, startPage + maxButtons - 1);

    // تنظیم startPage اگر endPage به last_page نزدیک باشد
    if (endPage - startPage < maxButtons - 1) {
      startPage = Math.max(2, endPage - maxButtons + 1);
    }

    // افزودن نقاط سه‌گانه قبل از صفحات میانی (اگر لازم باشد)
    if (startPage > 2) {
      buttons.push({
        page: null,
        label: "...",
        disabled: true,
      });
    }

    // افزودن دکمه‌های صفحات میانی
    for (let i = startPage; i <= endPage; i++) {
      buttons.push({
        page: i,
        label: i.toString(),
        disabled: current_page === i,
      });
    }

    // افزودن نقاط سه‌گانه بعد از صفحات میانی (اگر لازم باشد)
    if (endPage < last_page - 1) {
      buttons.push({
        page: null,
        label: "...",
        disabled: true,
      });
    }

    // دکمه صفحه آخر (اگر بیش از یک صفحه وجود داشته باشد)
    if (last_page > 1) {
      buttons.push({
        page: last_page,
        label: last_page.toString(),
        disabled: current_page === last_page,
      });
    }

    return buttons;
  };

// تابع مدیریت جستجوی دیتابیس با debounce
const fetchItemData = useCallback(
  debounce(async (id, value, updatedItems, otherItemsPercentage) => {
    if (!value) return; // اگر نام خالی باشد، جستجو انجام نشود
    const data = await fetchItemOrFoldNappeByName(value, "item");
    if (data && data.data) {
      console.log("داده دریافت‌شده:", data);
      const maxAllowedPercentage = 100 - otherItemsPercentage;
      const fetchedPercentage = data.data.percentage ? parseFloat(data.data.percentage) : 0;
      const adjustedPercentage = Math.min(fetchedPercentage, maxAllowedPercentage);

      if (fetchedPercentage > maxAllowedPercentage) {
        toast.warning(
          `درصد آیتم به ${adjustedPercentage}% تنظیم شد تا مجموع از 100% بیشتر نشود!`,
          { position: "top-center" }
        );
      }

      // به‌روزرسانی آیتم‌ها با داده‌های دریافت‌شده
      setItems(prevItems =>
        prevItems.map(item =>
          item.id === id
            ? {
                ...item,
                calories: data.data.calories ? parseFloat(data.data.calories) : item.calories || "",
                percentage: adjustedPercentage.toString(),
                rounding_method: data.data.rounding_method || item.rounding_method || "round_half",
              }
            : item
        )
      );

      // به‌روزرسانی درصد باقی‌مانده برای سفره‌چین‌ها پس از دریافت داده
      const remainingPercentage = calculateRemainingPercentage(updatedItems);
      setFoldNappes(prevFoldNappes =>
        prevFoldNappes.map(fold => ({
          ...fold,
          percentage: remainingPercentage.toString(),
        }))
      );
    }
  }, 500), // تاخیر 500 میلی‌ثانیه
  []
);

const handleItemChange = (id, field, value) => {
  // به‌روزرسانی اولیه آیتم‌ها با مقدار جدید
  const updatedItems = items.map(item =>
    item.id === id ? { ...item, [field]: value } : item
  );

  // اگر فیلد تغییر کرده "name" یا "percentage" باشد، بررسی‌ها انجام شود
  if (field === "name" || field === "percentage") {
    // محاسبه مجموع درصد آیتم‌های دیگر به جز آیتم فعلی
    const otherItemsPercentage = updatedItems
      .filter(item => item.id !== id)
      .reduce((sum, item) => sum + parseFloat(item.percentage || 0), 0);

    if (field === "name") {
      // ابتدا آیتم‌ها را به‌روزرسانی کنیم
      setItems(updatedItems);
      // فراخوانی تابع debounced برای جستجوی دیتابیس
      fetchItemData(id, value, updatedItems, otherItemsPercentage);
    } else if (field === "percentage") {
      // اعتبارسنجی درصد واردشده دستی
      const enteredPercentage = parseFloat(value) || 0;
      const maxAllowedPercentage = 100 - otherItemsPercentage;
      const adjustedPercentage = Math.min(enteredPercentage, maxAllowedPercentage);

      if (enteredPercentage > maxAllowedPercentage) {
        toast.warning(`حداکثر درصد مجاز ${maxAllowedPercentage}% است!`, {
          position: "top-center",
        });
      }

      // به‌روزرسانی آیتم با درصد تنظیم‌شده
      const updatedItemsWithPercentage = updatedItems.map(item =>
        item.id === id ? { ...item, percentage: adjustedPercentage.toString() } : item
      );
      setItems(updatedItemsWithPercentage);

      // به‌روزرسانی درصد باقی‌مانده برای سفره‌چین‌ها
      const remainingPercentage = calculateRemainingPercentage(updatedItemsWithPercentage);
      setFoldNappes(foldNappes.map(fold => ({
        ...fold,
        percentage: remainingPercentage.toString(),
      })));
    } else {
      setItems(updatedItems);
    }
  } else {
    // برای سایر فیلدها (مثل calories یا rounding_method) فقط آیتم به‌روزرسانی شود
    setItems(updatedItems);
  }

  // به‌روزرسانی درصد باقی‌مانده برای سفره‌چین‌ها (فقط برای فیلدهای غیر از percentage)
  if (field !== "percentage") {
    const remainingPercentage = calculateRemainingPercentage(updatedItems);
    setFoldNappes(foldNappes.map(fold => ({
      ...fold,
      percentage: remainingPercentage.toString(),
    })));
  }
};

  const handleFoldNappeChange = async (id, field, value) => {
    const updatedFoldNappes = foldNappes.map(fold => 
      fold.id === id ? { ...fold, [field]: value } : fold
    );
    setFoldNappes(updatedFoldNappes);
  
    // اگر فیلد تغییر کرده "name" باشه، جستجو در دیتابیس انجام بشه
    if (field === "name") {
      const data = await fetchItemOrFoldNappeByName(value, "fold_nappe");
      if (data && data.data) { // بررسی وجود data.data
        console.log("داده دریافت‌شده:", data); // برای دیباگ
        const updatedFoldNappesWithData = updatedFoldNappes.map(fold =>
          fold.id === id
            ? {
                ...fold,
                calories: data.data.calories ? parseFloat(data.data.calories) : fold.calories,
                arrangement: data.data.arrangement || fold.arrangement,
                rounding_method: data.data.rounding_method || fold.rounding_method
              }
            : fold
        );
        setFoldNappes(updatedFoldNappesWithData);
      }
    }
  };

  const addItem = () => {
    // محاسبه مجموع درصد آیتم‌ها
    const totalItemPercentage = items.reduce(
      (sum, item) => sum + parseFloat(item.percentage || 0),
      0
    );
    // محاسبه مجموع درصد سفره‌چین‌ها
    const foldNappePercentage = foldNappes.length > 0 ? parseFloat(foldNappes[0].percentage || 0) : 0;
    const totalFoldNappePercentage = foldNappes.length * foldNappePercentage;
    const totalPercentage = totalItemPercentage + totalFoldNappePercentage;

    // بررسی محدودیت مجموع درصد
    if (totalPercentage >= 100) {
      toast.warning("مجموع درصد آیتم‌ها و سفره‌چین‌ها به 100% رسیده است! نمی‌توانید آیتم جدید اضافه کنید.", {
        position: "top-center",
      });
      return;
    }

    // بررسی محدودیت تعداد آیتم‌ها
    if (items.length >= 5) {
      toast.warning("حداکثر ۵ آیتم می‌توانید اضافه کنید!", { position: "top-center" });
      return;
    }

    // افزودن آیتم جدید
    setItems([
      ...items,
      { id: Date.now(), name: "", calories: "", percentage: "", rounding_method: "round_half" }
    ]);

    // به‌روزرسانی درصد باقی‌مانده برای سفره‌چین‌ها
    const remainingPercentage = calculateRemainingPercentage([...items, { id: Date.now(), name: "", calories: "", percentage: "0", rounding_method: "round_half" }]);
    setFoldNappes(foldNappes.map(fold => ({
      ...fold,
      percentage: remainingPercentage.toString(),
    })));
  };

 // محاسبه درصد باقی‌مانده با در نظر گرفتن آیتم‌ها
 const calculateRemainingPercentage = (currentItems = items) => {
  const totalItemPercentage = currentItems.reduce(
    (sum, item) => sum + parseFloat(item.percentage || 0),
    0
  );
  return Math.max(0, 100 - totalItemPercentage);
};

  const addFoldNappe = () => {
    if (foldNappes.length >= 5) {
      toast.warning("حداکثر ۵ سفره‌چین می‌توانید اضافه کنید!", { position: "top-center" });
      return;
    }

    const remainingPercentage = calculateRemainingPercentage();

    setFoldNappes([
      ...foldNappes.map(fold => ({
        ...fold,
        percentage: remainingPercentage
      })),
      {
        id: Date.now(),
        name: "",
        arrangement: "",
        percentage: remainingPercentage,
        calories: "",
        rounding_method: "round_half"
      }
    ]);
  };

  const removeItem = (id) => {
    if (items.length > 1) {
      const updatedItems = items.filter(item => item.id !== id);
      setItems(updatedItems);

      const remainingPercentage = calculateRemainingPercentage(updatedItems);
      setFoldNappes(foldNappes.map(fold => ({
        ...fold,
        percentage: remainingPercentage
      })));
    }
  };

  const removeFoldNappe = (id) => {
    const newFoldNappes = foldNappes.filter(fold => fold.id !== id);
    const remainingPercentage = calculateRemainingPercentage();

    setFoldNappes(newFoldNappes.map(fold => ({
      ...fold,
      percentage: remainingPercentage
    })));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'additionalCategories' || name === 'additionalMeals') {
      const selectedOptions = Array.from(e.target.selectedOptions).map(option => option.value);
      setFormData({ ...formData, [name]: selectedOptions });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleDelete = async (id) => {
    setShowGlobalLoading(true);
    try {
      await axios.delete(`${serverUrl}food-list/${id}`);
      toast.success("منو با موفقیت حذف شد!", { position: "top-center" });
      fetchMenuList(pagination.current_page);
    } catch (error) {
      toast.error("خطا در حذف منو: " + (error.response?.data?.message || error.message), { position: "top-center" });
    } finally {
      setShowGlobalLoading(false);
    }
  };

  const handleEdit = (menu) => {
    setEditMenuId(menu.id);
    setFormType(menu.form_type || "menu");
    setFormData({
      name: menu.name,
      category: menu.form_type === "menu" ? menu.category : "", // فقط برای منو
      meal: menu.form_type === "menu" ? menu.meal : "", // فقط برای منو
      diet_type: menu.form_type === "menu" ? menu.diet_type || "" : "", // فقط برای منو
      portion_type: menu.form_type === "portion" ? menu.portion_type || "" : "",
      additionalCategories: [],
      additionalMeals: [],
      text: menu.text || ""
    });
    setItems(
      menu.items.map((item) => ({
        id: Date.now() + Math.random(),
        name: item.name,
        calories: item.calories,
        percentage: item.percentage,
        rounding_method: item.rounding_method,
      }))
    );
    setFoldNappes(
      menu.form_type === "menu" // فقط برای منو سفره‌چین‌ها را تنظیم کنید
        ? menu.fold_nappes.map((fold) => ({
            id: Date.now() + Math.random(),
            name: fold.name,
            arrangement: fold.arrangement,
            percentage: fold.percentage,
            calories: fold.calories,
            rounding_method: fold.rounding_method || "round_half",
          }))
        : [] // در حالت سهمیه، سفره‌چین‌ها خالی باشند
    );
    setShowEditModal(true);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (items.length === 0) {
      toast.error("حداقل یک آیتم باید وارد کنید!", { position: "top-center" });
      return;
    }
    if (items.some(item => !item.name || item.calories === "" || item.percentage === "" || !item.rounding_method)) {
      toast.error("لطفاً تمام فیلدهای آیتم‌ها را پر کنید!", { position: "top-center" });
      return;
    }
    if (formType === "menu" && foldNappes.length > 0 && foldNappes.some(fold => !fold.name || fold.percentage === "" || fold.calories === "" || !fold.arrangement || !fold.rounding_method)) {
      toast.error("لطفاً تمام فیلدهای سفره‌چین‌ها را پر کنید!", { position: "top-center" });
      return;
    }
    if (!formData.name) {
      toast.error(`لطفاً اسم ${formType === "menu" ? "غذا" : "سهمیه"} را وارد کنید!`, { position: "top-center" });
      return;
    }
    if (formType === "menu" && !formData.category) {
      toast.error("لطفاً یک دسته انتخاب کنید!", { position: "top-center" });
      return;
    }
    if (formType === "menu" && !formData.meal) {
      toast.error("لطفاً یک وعده انتخاب کنید!", { position: "top-center" });
      return;
    }
    if (formType === "portion" && !formData.portion_type) {
      toast.error("لطفاً نوع سهمیه را انتخاب کنید!", { position: "top-center" });
      return;
    }
     // محاسبه مجموع درصد آیتم‌ها
     const totalItemPercentagee = items.reduce((sum, item) => sum + parseFloat(item.percentage || 0), 0);
    
     // محاسبه درصد سفره‌چین (فقط اولین سفره‌چین اگر وجود داشته باشد)
     const foldNappePercentage = foldNappes.length > 0 ? parseFloat(foldNappes[0].percentage || 0) : 0;
     
     // بررسی مجموع درصد کل
     const totalPercentage = totalItemPercentagee + foldNappePercentage;
     if (totalPercentage !== 100) {
       toast.error("مجموع درصد آیتم‌ها و سفره‌چین باید دقیقاً ۱۰۰ باشد!", { position: "top-center" });
       return;
     }

    // اعتبارسنجی اعداد صحیح برای کالری
    // برای آیتم‌ها
for (const item of items) {
  const calories = parseFloat(item.calories);
  const percentage = parseFloat(item.percentage);
  if (isNaN(calories) || calories < 0) {
    toast.error("کالری باید یک عدد غیرمنفی باشد!", { position: "top-center" });
    return;
  }
  if (isNaN(percentage) || percentage < 0 || percentage > 100) {
    toast.error("درصد باید یک عدد معتبر بین ۰ تا ۱۰۰ باشد!", { position: "top-center" });
    return;
  }
}

// برای سفره‌چین‌ها
for (const fold of foldNappes) {
  const calories = parseFloat(fold.calories);
  const percentage = parseFloat(fold.percentage);
  if (isNaN(calories) || calories < 0) {
    toast.error("کالری سفره‌چین‌ها باید یک عدد غیرمنفی باشد!", { position: "top-center" });
    return;
  }
  if (isNaN(percentage) || percentage < 0 || percentage > 100) {
    toast.error("درصد سفره‌چین‌ها باید یک عدد معتبر بین ۰ تا ۱۰۰ باشد!", { position: "top-center" });
    return;
  }
}

    const totalItemPercentage = items.reduce((sum, item) => sum + parseInt(item.percentage || 0), 0);
    if (totalItemPercentage > 100) {
      toast.error("مجموع درصد آیتم‌ها نمی‌تواند بیشتر از ۱۰۰ باشد!", { position: "top-center" });
      return;
    }

    const expectedFoldNappePercentage = calculateRemainingPercentage();
    if (foldNappes.length > 0 && foldNappes.some(fold => parseInt(fold.percentage) !== expectedFoldNappePercentage)) {
      toast.error(`درصد هر سفره‌چین باید ${expectedFoldNappePercentage} باشد!`, { position: "top-center" });
      return;
    }

    setShowGlobalLoading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('category', formData.category);
      formDataToSend.append('meal', formData.meal);
      formDataToSend.append('diet_type', formData.diet_type);
      formDataToSend.append('portion_type', formData.portion_type);
      formDataToSend.append('form_type', formType);
      formDataToSend.append('text', formData.text || '');

      items.forEach((item, index) => {
        formDataToSend.append(`item${index + 1}`, item.name);
        formDataToSend.append(`calories_item${index + 1}`, parseFloat(item.calories)); // تغییر به parseFloat
        formDataToSend.append(`percentage_item${index + 1}`, parseFloat(item.percentage)); // تغییر به parseFloat
        formDataToSend.append(`rounding_method_item${index + 1}`, item.rounding_method);
      });

      for (let i = items.length; i < 5; i++) {
        formDataToSend.append(`item${i + 1}`, '');
        formDataToSend.append(`calories_item${i + 1}`, '');
        formDataToSend.append(`percentage_item${i + 1}`, '');
        formDataToSend.append(`rounding_method_item${i + 1}`, '');
      }

      foldNappes.forEach((fold, index) => {
        formDataToSend.append(`fold_nappe${index + 1}`, fold.name);
        formDataToSend.append(`arrangement_fold_nappe${index + 1}`, fold.arrangement);
        formDataToSend.append(`percentage_fold_nappe${index + 1}`, parseFloat(fold.percentage)); // تغییر به parseFloat
        formDataToSend.append(`calories_fold_nappe${index + 1}`, parseFloat(fold.calories)); // تغییر به parseFloat
        formDataToSend.append(`rounding_method_fold_nappe${index + 1}`, fold.rounding_method);
      });

      for (let i = foldNappes.length; i < 5; i++) {
        formDataToSend.append(`fold_nappe${i + 1}`, '');
        formDataToSend.append(`arrangement_fold_nappe${i + 1}`, '');
        formDataToSend.append(`percentage_fold_nappe${i + 1}`, '');
        formDataToSend.append(`calories_fold_nappe${i + 1}`, '');
        formDataToSend.append(`rounding_method_fold_nappe${i + 1}`, '');
      }

      await axios.post(`${serverUrl}food-list/${editMenuId}`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      toast.success(`${formType === "menu" ? "منو" : "سهمیه"} با موفقیت ویرایش شد!`, { position: "top-center" });
      setShowEditModal(false);
      setItems([{ id: Date.now(), name: "", calories: "", percentage: "", rounding_method: "round_half" }]);
      setFoldNappes([]);
      setFormData({ 
        name: "", 
        category: "", 
        meal: "", 
        diet_type: "",
        additionalCategories: [], 
        additionalMeals: [], 
        text: "" 
      });
      fetchMenuList(pagination.current_page);
    } catch (error) {
      if (error.response?.data?.errors) {
        const errorMessages = Object.values(error.response.data.errors).flat().join(', ');
        toast.error(`خطا در ویرایش ${formType === "menu" ? "منو" : "سهمیه"}: ${errorMessages}`, { position: "top-center" });
      } else {
        toast.error(`خطا در ویرایش ${formType === "menu" ? "منو" : "سهمیه"}: ` + (error.response?.data?.message || error.message), { position: "top-center" });
      }
    } finally {
      setShowGlobalLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (items.length === 0) {
      toast.error("حداقل یک آیتم باید وارد کنید!", { position: "top-center" });
      return;
    }
    if (items.some((item) => !item.name || item.calories === "" || item.percentage === "" || !item.rounding_method)) {
      toast.error("لطفاً تمام فیلدهای آیتم‌ها را پر کنید!", { position: "top-center" });
      return;
    }
    if (formType === "menu" && foldNappes.length > 0 && foldNappes.some((fold) => !fold.name || fold.percentage === "" || fold.calories === "" || !fold.arrangement || !fold.rounding_method)) {
      toast.error("لطفاً تمام فیلدهای سفره‌چین‌ها را پر کنید!", { position: "top-center" });
      return;
    }
    if (!formData.name) {
      toast.error(`لطفاً اسم ${formType === "menu" ? "غذا" : "سهمیه"} را وارد کنید!`, { position: "top-center" });
      return;
    }
    if (formType === "menu" && !formData.category) {
      toast.error("لطفاً یک دسته انتخاب کنید!", { position: "top-center" });
      return;
    }
    if (formType === "menu" && !formData.meal) {
      toast.error("لطفاً یک وعده انتخاب کنید!", { position: "top-center" });
      return;
    }
    if (formType === "portion" && !formData.portion_type) {
      toast.error("لطفاً نوع سهمیه را انتخاب کنید!", { position: "top-center" });
      return;
    }

      // محاسبه مجموع درصد آیتم‌ها
    const totalItemPercentagee = items.reduce((sum, item) => sum + parseFloat(item.percentage || 0), 0);
    
    // محاسبه درصد سفره‌چین (فقط اولین سفره‌چین اگر وجود داشته باشد)
    const foldNappePercentage = foldNappes.length > 0 ? parseFloat(foldNappes[0].percentage || 0) : 0;
    
    // بررسی مجموع درصد کل
    const totalPercentage = totalItemPercentagee + foldNappePercentage;
    if (totalPercentage !== 100) {
      toast.error("مجموع درصد آیتم‌ها و سفره‌چین باید دقیقاً ۱۰۰ باشد!", { position: "top-center" });
      return;
    }

    // اعتبارسنجی اعداد صحیح برای کالری
    for (const item of items) {
      const calories = parseFloat(item.calories);
      const percentage = parseFloat(item.percentage);
      if (isNaN(calories) || calories < 0) {
        toast.error("کالری باید یک عدد غیرمنفی باشد!", { position: "top-center" });
        return;
      }
      if (isNaN(percentage) || percentage < 0 || percentage > 100) {
        toast.error("درصد باید یک عدد معتبر بین ۰ تا ۱۰۰ باشد!", { position: "top-center" });
        return;
      }
    }
    
    for (const fold of foldNappes) {
      const calories = parseFloat(fold.calories);
      const percentage = parseFloat(fold.percentage);
      if (isNaN(calories) || calories < 0) {
        toast.error("کالری سفره‌چین‌ها باید یک عدد غیرمنفی باشد!", { position: "top-center" });
        return;
      }
      if (isNaN(percentage) || percentage < 0 || percentage > 100) {
        toast.error("درصد سفره‌چین‌ها باید یک عدد معتبر بین ۰ تا ۱۰۰ باشد!", { position: "top-center" });
        return;
      }
    }

    const totalItemPercentage = items.reduce((sum, item) => sum + parseInt(item.percentage || 0), 0);
    if (totalItemPercentage > 100) {
      toast.error("مجموع درصد آیتم‌ها نمی‌تواند بیشتر از ۱۰۰ باشد!", { position: "top-center" });
      return;
    }

    const expectedFoldNappePercentage = calculateRemainingPercentage();
    if (foldNappes.length > 0 && foldNappes.some(fold => parseInt(fold.percentage) !== expectedFoldNappePercentage)) {
      toast.error(`درصد هر سفره‌چین باید ${expectedFoldNappePercentage} باشد!`, { position: "top-center" });
      return;
    }

    setShowGlobalLoading(true);

    try {
      const combinations = formType === "menu" ? [
        { category: formData.category, meal: formData.meal, diet_type: formData.diet_type },
        ...formData.additionalCategories.map(category => ({
          category,
          meal: formData.meal,
          diet_type: formData.diet_type
        })),
        ...formData.additionalMeals.map(meal => ({
          category: formData.category,
          meal,
          diet_type: formData.diet_type
        }))
      ] : [{ category: "", meal: "", diet_type: "" ,portion_type: formData.portion_type }];

      for (const { category, meal , diet_type , portion_type} of combinations) {
        const formDataToSend = new FormData();
        formDataToSend.append('name', formData.name);
        formDataToSend.append('category', category);
        formDataToSend.append('meal', meal);
        formDataToSend.append('diet_type', diet_type);
        formDataToSend.append('portion_type', portion_type);
        formDataToSend.append('form_type', formType);
        formDataToSend.append('text', formData.text || '');

        items.forEach((item, index) => {
          formDataToSend.append(`item${index + 1}`, item.name);
          formDataToSend.append(`calories_item${index + 1}`, parseFloat(item.calories)); // تغییر به parseFloat
          formDataToSend.append(`percentage_item${index + 1}`, parseFloat(item.percentage)); // تغییر به parseFloat
          formDataToSend.append(`rounding_method_item${index + 1}`, item.rounding_method);
        });

        for (let i = items.length; i < 5; i++) {
          formDataToSend.append(`item${i + 1}`, '');
          formDataToSend.append(`calories_item${i + 1}`, '');
          formDataToSend.append(`percentage_item${i + 1}`, '');
          formDataToSend.append(`rounding_method_item${i + 1}`, '');
        }

        foldNappes.forEach((fold, index) => {
          formDataToSend.append(`fold_nappe${index + 1}`, fold.name);
          formDataToSend.append(`arrangement_fold_nappe${index + 1}`, fold.arrangement);
          formDataToSend.append(`percentage_fold_nappe${index + 1}`, parseFloat(fold.percentage)); // تغییر به parseFloat
          formDataToSend.append(`calories_fold_nappe${index + 1}`, parseFloat(fold.calories)); // تغییر به parseFloat
          formDataToSend.append(`rounding_method_fold_nappe${index + 1}`, fold.rounding_method);
        });

        for (let i = foldNappes.length; i < 5; i++) {
          formDataToSend.append(`fold_nappe${i + 1}`, '');
          formDataToSend.append(`arrangement_fold_nappe${i + 1}`, '');
          formDataToSend.append(`percentage_fold_nappe${i + 1}`, '');
          formDataToSend.append(`calories_fold_nappe${i + 1}`, '');
          formDataToSend.append(`rounding_method_fold_nappe${i + 1}`, '');
        }

        await axios.post(serverUrl + 'food-list', formDataToSend, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      }

      // دریافت لیست جدید برای به‌روزرسانی pagination
  const response = await axios.get(serverUrl + 'get-food-list', {
    params: { page: 1, search: searchQuery, category: filterCategory, meal: filterMeal }
  });

  // به‌روزرسانی pagination
  setPagination(response.data.pagination);

  // تنظیم پرچم برای رفتن به صفحه آخر
  setShouldGoToLastPage(true);

  // فراخوانی fetchMenuList برای صفحه آخر
  await fetchMenuList(response.data.pagination.last_page);



      toast.success("منوها با موفقیت ثبت شدند!", { position: "top-center" });
      setItems([{ id: Date.now(), name: "", calories: "", percentage: "", rounding_method: "round_half" }]);
      setFoldNappes([]);
      setFormData({ 
        name: "", 
        category: "", 
        meal: "", 
        diet_type: "",
        additionalCategories: [], 
        additionalMeals: [], 
        text: "" 
      });
      setShowForm(false);
      
    
    } catch (error) {
      if (error.response?.data?.errors) {
        const errorMessages = Object.values(error.response.data.errors).flat().join(', ');
        toast.error(`خطا در ثبت ${formType === "menu" ? "منو" : "سهمیه"}: ${errorMessages}`, { position: "top-center" });
      } else {
        toast.error(`خطا در ثبت ${formType === "menu" ? "منو" : "سهمیه"}: ` + (error.response?.data?.message || error.message), { position: "top-center" });
      }
    } finally {
      setShowGlobalLoading(false);
    }
  };

  const handleCopy = () => {
    const dataToCopy = {
      formData: { ...formData },
      items: items.map(item => ({ ...item, id: Date.now() + Math.random() })),
      foldNappes: foldNappes.map(fold => ({ ...fold, id: Date.now() + Math.random() }))
    };
    setCopiedData(dataToCopy);
    toast.success("اطلاعات با موفقیت کپی شد!", { position: "top-center" });
  };

  const handlePaste = () => {
    if (!copiedData) {
      toast.error("هیچ اطلاعاتی برای پیست کردن وجود ندارد!", { position: "top-center" });
      return;
    }
    setFormData({ ...copiedData.formData });
    setItems(copiedData.items);
    const totalItemPercentage = copiedData.items.reduce((sum, item) => sum + parseInt(item.percentage || 0), 0);
    const remainingPercentage = calculateRemainingPercentage(copiedData.items);
    setFoldNappes(copiedData.foldNappes.map(fold => ({
      ...fold,
      percentage: remainingPercentage
    })));
    toast.success("اطلاعات با موفقیت پیست شد!", { position: "top-center" });
  };

  const handleResetFilters = () => {
    setSearchQuery("");
    setFilterCategory("");
    setFilterOver100(false);
    setFilterMeal("");
    setFilterWithoutGroup(false);
    setPagination({ ...pagination, current_page: 1 });
    fetchMenuList(1, true);
  };

  const containerStyle = {
    background: "linear-gradient(180deg, #1e2a44 0%, #141b2d 100%)",
    minHeight: "100vh",
    padding: "100px 200px 40px 20px",
    fontFamily: "'Dana', sans-serif",
    color: "#e2e8f0",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start"
  };

  const cardStyle = {
    background: "rgba(255, 255, 255, 0.08)",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    width: "100%",
    overflow: "hidden",
    border: "1px solid rgba(255, 255, 255, 0.15)"
  };

  const buttonStyle = {
    background: "linear-gradient(45deg, #f472b6, #f9a8d4)",
    border: "none",
    borderRadius: "8px",
    padding: "10px 24px",
    color: "white",
    fontWeight: "500",
    fontSize: "0.95rem",
    transition: "all 0.2s ease",
    fontFamily: "'Dana', sans-serif",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px"
  };

  const buttonHoverStyle = {
    background: "linear-gradient(45deg, #f9a8d4, #f472b6)",
    transform: "translateY(-2px)"
  };

  const buttonDisabledStyle = {
    opacity: 0.5,
    cursor: "not-allowed"
  };

  const formStyle = {
    padding: "24px",
    borderRadius: "8px",
    background: formType === "portion" ? "rgba(255, 255, 255, 0.1)" : "rgba(255, 255, 255, 0.06)",
    border: formType === "portion" ? "1px solid rgba(255, 255, 255, 0.3)" : "1px solid rgba(255, 255, 255, 0.1)",
    marginBottom: "24px",
  };

  const modalStyle = {
    background: "#1e2a44",
    borderRadius: "12px",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    color: "#e2e8f1",
    fontFamily: "'Dana', sans-serif",
    maxWidth: "800px",
    width: "100%",
    margin: "auto"
  };

  const inputStyle = {
    borderRadius: "8px",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    padding: "6px",
    width: "100%",
    background: "rgba(255, 255, 255, 0.03)",
    color: "#e2e8f0",
    fontSize: "0.9rem",
    fontFamily: "'Dana', sans-serif",
    transition: "border-color 0.2s ease"
  };

  const selectStyle = {
    ...inputStyle,
    height: "auto",
    overflowY: "auto"
  };

  const multiSelectStyle = {
    ...inputStyle,
    height: "100px",
    overflowY: "auto"
  };

  const labelStyle = {
    fontWeight: "500",
    color: "#d1d5db",
    marginBottom: "8px",
    fontSize: "0.85rem",
    fontFamily: "'Dana', sans-serif",
    background: "linear-gradient(45deg, #a855f7, #d8b4fe)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent"
  };

  const tableContainerStyle = {
    maxWidth: "100%",
    overflowX: "auto",
    // maxHeight را حذف کنید یا مقدار آن را افزایش دهید
    // maxHeight: "500px", // این خط را کامنت کنید یا حذف کنید
    overflowY: "auto", // اگر نیازی به اسکرول نیست، این را هم می‌توانید حذف کنید
    marginTop: "16px"
  };

  const tableStyle = {
    background: "rgba(255, 255, 255, 0.05)",
    borderRadius: "8px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    fontFamily: "'Dana', sans-serif",
    color: "#e2e8f0",
    width: "100%",
    minWidth: "1200px"
  };

  const tableHeaderStyle = {
    background: "linear-gradient(45deg, #2d3748, #374151)",
    color: "#e2e8f0",
    fontWeight: "600",
    fontSize: "0.85rem",
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderBottom: "1px solid rgba(255, 255, 255, 0.15)"
  };

  const tableRowStyle = {
    transition: "background 0.2s ease",
    borderBottom: "1px solid rgba(255, 255, 255, 0.08)"
  };

  const tableCellStyle = {
    padding: "12px 16px",
    fontSize: "0.85rem",
    fontFamily: "'Dana', sans-serif",
    color: "#d1d5db",
    minWidth: "120px",
    whiteSpace: "normal", // تغییر به normal برای اجازه دادن به شکستن خط
    overflow: "visible", // حذف مخفی‌سازی متن
    textAlign: "center"
  };

  const paginationStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "16px",
    gap: "8px"
  };

  const pageButtonStyle = {
    background: "linear-gradient(45deg, #4b5563, #6b7280)",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    color: "#e2e8f0",
    fontSize: "0.85rem",
    fontFamily: "'Dana', sans-serif",
    cursor: "pointer",
    transition: "all 0.2s ease"
  };

  const pageButtonHoverStyle = {
    background: "linear-gradient(45deg, #6b7280, #4b5563)",
    transform: "translateY(-1px)"
  };

  const pageButtonActiveStyle = {
    background: "linear-gradient(45deg, #f472b6, #f9a8d4)",
    fontWeight: "600"
  };

  const pageButtonDisabledStyle = {
    opacity: 0.5,
    cursor: "not-allowed"
  };

  const roundingMethodLabels = {
    round_half: "گرد به ۰.۵",
    round_5g: "گرد به ۵ گرم",
    round_quarter: "گرد به یک‌چهارم",
    round_full: "گرد کردن واحد کامل"
  };

  const checkboxStyle = {
    marginRight: "8px",
    cursor: "pointer",
    accentColor: "#f472b6"
  };

  return (
    <>
      <ToastContainer />
      <div className="content" style={containerStyle}>
        {showGlobalLoading ? (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)'
          }}>
            <RingLoader size="60px" color="#f472b6" />
          </div>
        ) : (
          <Row style={{width:'90%'}}>
            <Col md="12">
              <Card style={cardStyle}>
                <CardHeader style={{ borderBottom: "none", padding: "24px", textAlign: "center" }}>
                  <h3 style={{ 
                    color: "#e2e8f0",
                    fontWeight: "600", 
                    fontSize: "1.5rem", 
                    fontFamily: "'Dana', sans-serif"
                  }}>
                    مدیریت منوی غذا
                  </h3>
                  <Button
                    style={buttonStyle}
                    onClick={() => setShowForm(!showForm)}
                    onMouseOver={(e) => Object.assign(e.target.style, buttonHoverStyle)}
                    onMouseOut={(e) => Object.assign(e.target.style, { 
                      background: "linear-gradient(45deg, #f472b6, #f9a8d4)", 
                      transform: "none" 
                    })}
                  >
                    <i className={`fas ${showForm ? 'fa-times' : 'fa-plus'}`} style={{ fontSize: "0.8rem" }} />
                    {showForm ? "بستن فرم" : "ایجاد منوی جدید"}
                  </Button>
                </CardHeader>
                <CardBody style={{ padding: "0 24px 24px" }}>
                  {showForm && (
                    <>
                    <div style={{ marginBottom: "16px", display: "flex", gap: "8px", justifyContent: "center" }}>
    <Button
      style={{
        ...buttonStyle,
        background: formType === "menu" ? "linear-gradient(45deg, #f472b6, #f9a8d4)" : "linear-gradient(45deg, #6b7280, #4b5563)",
      }}
      onClick={() => setFormType("menu")}
      onMouseOver={(e) => Object.assign(e.target.style, {
        background: formType === "menu" ? "linear-gradient(45deg, #f9a8d4, #f472b6)" : "linear-gradient(45deg, #4b5563, #6b7280)",
        transform: "translateY(-2px)",
      })}
      onMouseOut={(e) => Object.assign(e.target.style, {
        background: formType === "menu" ? "linear-gradient(45deg, #f472b6, #f9a8d4)" : "linear-gradient(45deg, #6b7280, #4b5563)",
        transform: "none",
      })}
    >
      منو
    </Button>
    <Button
      style={{
        ...buttonStyle,
        background: formType === "portion" ? "linear-gradient(45deg, #f472b6, #f9a8d4)" : "linear-gradient(45deg, #6b7280, #4b5563)",
      }}
      onClick={() => setFormType("portion")}
      onMouseOver={(e) => Object.assign(e.target.style, {
        background: formType === "portion" ? "linear-gradient(45deg, #f9a8d4, #f472b6)" : "linear-gradient(45deg, #4b5563, #6b7280)",
        transform: "translateY(-2px)",
      })}
      onMouseOut={(e) => Object.assign(e.target.style, {
        background: formType === "portion" ? "linear-gradient(45deg, #f472b6, #f9a8d4)" : "linear-gradient(45deg, #6b7280, #4b5563)",
        transform: "none",
      })}
    >
      سهمیه
    </Button>
                    </div>
                    
                    <form onSubmit={handleSubmit} style={formStyle}>
  {items.map((item, index) => (
    <Row key={item.id} style={{ marginBottom: "16px", alignItems: "center" }}>
      <Col md="3">
        <FormGroup>
          <Label style={labelStyle}>آیتم {["اول", "دوم", "سوم", "چهارم", "پنجم"][index]}</Label>
          <Input
            type="text"
            value={item.name}
            onChange={(e) => handleItemChange(item.id, "name", e.target.value)}
            style={inputStyle}
            placeholder={`نام آیتم ${["اول", "دوم", "سوم", "چهارم", "پنجم"][index]}`}
            required
            onFocus={(e) => e.target.style.borderColor = "#f472b6"}
            onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
          />
        </FormGroup>
      </Col>
      <Col md="2">
        <FormGroup>
          <Label style={labelStyle}>کالری</Label>
          <Input
            type="number"
            value={item.calories}
            onChange={(e) => handleItemChange(item.id, "calories", e.target.value)}
            style={inputStyle}
            placeholder="کالری"
            min="0"
            step="0.1"
            required
            onFocus={(e) => e.target.style.borderColor = "#f472b6"}
            onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
          />
        </FormGroup>
      </Col>
      <Col md="2">
        <FormGroup>
          <Label style={labelStyle}>درصد</Label>
          <Input
            type="number"
            value={item.percentage}
            onChange={(e) => handleItemChange(item.id, "percentage", e.target.value)}
            style={inputStyle}
            placeholder="درصد"
            min="0"
            max="100"
            required
            onFocus={(e) => e.target.style.borderColor = "#f472b6"}
            onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
          />
        </FormGroup>
      </Col>
      <Col md="3">
        <FormGroup>
          <Label style={labelStyle}>نوع گرد کردن</Label>
          <Input
            type="select"
            value={item.rounding_method}
            onChange={(e) => handleItemChange(item.id, "rounding_method", e.target.value)}
            style={inputStyle}
            required
            onFocus={(e) => e.target.style.borderColor = "#f472b6"}
            onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
          >
            <option value="round_half">گرد به ۰.۵</option>
            <option value="round_5g">گرد به ۵ گرم</option>
            <option value="round_quarter">گرد به یک‌چهارم</option>
            <option value="round_full">گرد کردن واحد کامل</option>
          </Input>
        </FormGroup>
      </Col>
      <Col md="2" style={{ display: "flex", alignItems: "center" }}>
        {items.length > 1 && (
          <Button
            color="danger"
            size="sm"
            onClick={() => removeItem(item.id)}
            style={{ padding: "8px", borderRadius: "6px" }}
          >
            <i className="fas fa-trash" />
          </Button>
        )}
      </Col>
    </Row>
  ))}
  <Button
    style={{
      ...buttonStyle,
      background: "linear-gradient(45deg, #38a169, #48bb78)",
      ...(items.length >= 5 ? buttonDisabledStyle : {}),
    }}
    onClick={addItem}
    disabled={items.length >= 5}
    onMouseOver={(e) =>
      items.length < 5 &&
      Object.assign(e.target.style, {
        background: "linear-gradient(45deg, #48bb78, #38a169)",
        transform: "translateY(-2px)",
      })
    }
    onMouseOut={(e) =>
      Object.assign(e.target.style, {
        background: "linear-gradient(45deg, #38a169, #48bb78)",
        transform: "none",
      })
    }
  >
    <i className="fas fa-plus-circle" />
    افزودن آیتم جدید
  </Button>
  {formType === "menu" && foldNappes.length > 0 &&
    foldNappes.map((fold, index) => (
      <Row key={fold.id} style={{ marginBottom: "16px", alignItems: "center", marginTop: "16px" }}>
        <Col md="2">
          <FormGroup>
            <Label style={labelStyle}>سفره‌چین {["اول", "دوم", "سوم", "چهارم", "پنجم"][index]}</Label>
            <Input
              type="text"
              value={fold.name}
              onChange={(e) => handleFoldNappeChange(fold.id, "name", e.target.value)}
              style={inputStyle}
              placeholder={`اسم سفره‌چین ${["اول", "دوم", "سوم", "چهارم", "پنجم"][index]}`}
              required
              onFocus={(e) => e.target.style.borderColor = "#f472b6"}
              onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
            />
          </FormGroup>
        </Col>
        <Col md="2">
          <FormGroup>
            <Label style={labelStyle}>نحوه چیدمان</Label>
            <Input
              type="text"
              value={fold.arrangement}
              onChange={(e) => handleFoldNappeChange(fold.id, "arrangement", e.target.value)}
              style={inputStyle}
              placeholder="مثال: $عدد خرما"
              required
              onFocus={(e) => e.target.style.borderColor = "#f472b6"}
              onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
            />
          </FormGroup>
        </Col>
        <Col md="2">
          <FormGroup>
            <Label style={labelStyle}>درصد</Label>
            <Input
              type="number"
              value={fold.percentage}
              disabled
              style={inputStyle}
              placeholder="درصد"
              onFocus={(e) => e.target.style.borderColor = "#f472b6"}
              onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
            />
          </FormGroup>
        </Col>
        <Col md="2">
          <FormGroup>
            <Label style={labelStyle}>کالری</Label>
            <Input
              type="number"
              value={fold.calories}
              onChange={(e) => handleFoldNappeChange(fold.id, "calories", e.target.value)}
              style={inputStyle}
              placeholder="کالری"
              min="0"
              step="0.1"
              required
              onFocus={(e) => e.target.style.borderColor = "#f472b6"}
              onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
            />
          </FormGroup>
        </Col>
        <Col md="2">
          <FormGroup>
            <Label style={labelStyle}>نوع گرد کردن</Label>
            <Input
              type="select"
              value={fold.rounding_method}
              onChange={(e) => handleFoldNappeChange(fold.id, "rounding_method", e.target.value)}
              style={inputStyle}
              required
              onFocus={(e) => e.target.style.borderColor = "#f472b6"}
              onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
            >
              <option value="round_half">گرد به ۰.۵</option>
              <option value="round_5g">گرد به ۵ گرم</option>
              <option value="round_quarter">گرد به یک‌چهارم</option>
              <option value="round_full">گرد کردن واحد کامل</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md="2" style={{ display: "flex", alignItems: "center" }}>
          <Button
            color="danger"
            size="sm"
            onClick={() => removeFoldNappe(fold.id)}
            style={{ padding: "8px", borderRadius: "6px" }}
          >
            <i className="fas fa-trash" />
          </Button>
        </Col>
      </Row>
    ))}
  {formType === "menu" && (
    <Button
      style={{
        ...buttonStyle,
        background: "linear-gradient(45deg, #38a169, #48bb78)",
        ...(foldNappes.length >= 5 ? buttonDisabledStyle : {}),
      }}
      onClick={addFoldNappe}
      disabled={foldNappes.length >= 5}
      onMouseOver={(e) =>
        foldNappes.length < 5 &&
        Object.assign(e.target.style, {
          background: "linear-gradient(45deg, #48bb78, #38a169)",
          transform: "translateY(-2px)",
        })
      }
      onMouseOut={(e) =>
        Object.assign(e.target.style, {
          background: "linear-gradient(45deg, #38a169, #48bb78)",
          transform: "none",
        })
      }
    >
      <i className="fas fa-plus-circle" />
      افزودن سفره‌چین جدید
    </Button>
  )}
  <Row style={{ marginBottom: "16px", marginTop: "16px" }}>
    <Col md="6">
      <FormGroup>
        <Label style={labelStyle}>اسم {formType === "menu" ? "غذا" : "سهمیه"}</Label>
        <Input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          style={inputStyle}
          placeholder={`اسم ${formType === "menu" ? "غذا" : "سهمیه"}`}
          required
          onFocus={(e) => e.target.style.borderColor = "#f472b6"}
          onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
        />
      </FormGroup>
    </Col>

    {formType === "portion" && (
    <Col md="6">
      <FormGroup>
        <Label style={labelStyle}>نوع سهمیه</Label>
        <Input
          type="select"
          name="portion_type"
          value={formData.portion_type}
          onChange={handleInputChange}
          style={selectStyle}
          required
          onFocus={(e) => e.target.style.borderColor = "#f472b6"}
          onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
        >
          <option value="">یک نوع سهمیه انتخاب کنید</option>
          <option value="سهمیه لبنیات">سهمیه لبنیات</option>
          <option value="سهمیه روغن زیتون">سهمیه روغن زیتون</option>
          <option value="سهمیه قند">سهمیه قند</option>
          <option value="سهمیه آجیل">سهمیه آجیل</option>
        </Input>
      </FormGroup>
    </Col>
  )}

{formType === "portion" && (
  <Col md="6">
  <FormGroup>
    <Label style={labelStyle}>نحوه چیدمان سهمیه</Label>
    <Input
      type="textarea"
      name="text"
      value={formData.text}
      onChange={handleInputChange}
      style={{ ...inputStyle, height: "80px", resize: "none" }}
      placeholder="مقداری که سیستم به دست میاره با $ نشان دهید مثال : $عدد شیر+$عدد خرما"
      onFocus={(e) => e.target.style.borderColor = "#f472b6"}
      onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
    />
  </FormGroup>
  </Col>
)}
    {formType === "menu" && (
      <Col md="6">
        <FormGroup>
          <Label style={labelStyle}>دسته</Label>
          <Input
            type="select"
            name="category"
            value={formData.category}
            onChange={handleInputChange}
            style={selectStyle}
            required
            onFocus={(e) => e.target.style.borderColor = "#f472b6"}
            onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
          >
            <option value="">یک دسته انتخاب کنید</option>
            <option value="منوی رژیم غذایی متعادل و همه چیز خواری تمام فصول">منوی رژیم غذایی متعادل و همه چیز خواری تمام فصول</option>
            <option value="منو رژیم غذایی گیاه خواری همراه با شیر و تخم مرغ">منو رژیم غذایی گیاه خواری همراه با شیر و تخم مرغ</option>
            <option value="منو رژیم غذایی پر پروتئین">منو رژیم غذایی پر پروتئین</option>
            <option value="منو رژیم غذایی متعادل و همه چیز خواری مختص فصول گرم">منو رژیم غذایی متعادل و همه چیز خواری گرم</option>
            <option value="منو رژیم غذایی متعادل و همه چیز خواری مختص فصول سرد">منو رژیم غذایی متعادل و همه چیز خواری سرد</option>
          </Input>
        </FormGroup>
      </Col>
    )}
  </Row>
  {formType === "menu" && (
    <Row style={{ marginBottom: "16px" }}>
      <Col md="6">
        <FormGroup>
          <Label style={labelStyle}>وعده</Label>
          <Input
            type="select"
            name="meal"
            value={formData.meal}
            onChange={handleInputChange}
            style={selectStyle}
            required
            onFocus={(e) => e.target.style.borderColor = "#f472b6"}
            onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
          >
            <option value="">یک وعده انتخاب کنید</option>
            <option value="صبحانه">صبحانه</option>
            <option value="بعد از صبحانه">بعد از صبحانه</option>
            <option value="میان‌وعده صبح">میان‌وعده صبح</option>
            <option value="ناهار">ناهار</option>
            <option value="بعد از ناهار">بعد از ناهار</option>
            <option value="میان‌وعده عصر">میان‌وعده عصر</option>
            <option value="شام">شام</option>
            <option value="بعد از شام">بعد از شام</option>
            <option value="خوراکی خوشمزه بعد از شام">خوراکی خوشمزه بعد از شام</option>
          </Input>
        </FormGroup>
      </Col>
      {/* <Col md="6">
        <FormGroup>
          <Label style={labelStyle}>نوع رژیم</Label>
          <Input
            type="select"
            name="diet_type"
            value={formData.diet_type}
            onChange={handleInputChange}
            style={selectStyle}
            onFocus={(e) => e.target.style.borderColor = "#f472b6"}
            onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
          >
            <option value="">مشترک</option>
            <option value="weight_loss">رژیم کاهش وزن</option>
            <option value="weight_gain">رژیم افزایش وزن</option>
            <option value="weight_maintenance">رژیم ثبات وزن</option>
          </Input>
        </FormGroup>
      </Col> */}
    </Row>
  )}
  {formType === "menu" && (
    <FormGroup>
      <Label style={labelStyle}>نحوه چیدمان منو</Label>
      <Input
        type="textarea"
        name="text"
        value={formData.text}
        onChange={handleInputChange}
        style={{ ...inputStyle, height: "80px", resize: "none" }}
        placeholder="مقداری که سیستم به دست میاره با $ نشان دهید مثال : $عدد کیک+$عدد شیر"
        onFocus={(e) => e.target.style.borderColor = "#f472b6"}
        onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
      />
    </FormGroup>
  )}
  {formType === "menu" && (
    <Row style={{ marginBottom: "16px", marginTop: "16px" }}>
      <Col md="6">
        <FormGroup>
          <Label style={labelStyle}>کپی برای دسته‌های دیگر (اختیاری)</Label>
          <Input
            type="select"
            name="additionalCategories"
            value={formData.additionalCategories}
            onChange={handleInputChange}
            style={multiSelectStyle}
            multiple
            onFocus={(e) => e.target.style.borderColor = "#f472b6"}
            onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
          >
            <option value="منوی رژیم غذایی متعادل و همه چیز خواری تمام فصول">منوی رژیم غذایی متعادل و همه چیز خواری تمام فصول</option>
            <option value="منو رژیم غذایی گیاه خواری همراه با شیر و تخم مرغ">منو رژیم غذایی گیاه خواری همراه با شیر و تخم مرغ</option>
            <option value="منو رژیم غذایی پر پروتئین">منو رژیم غذایی پر پروتئین</option>
            <option value="منو رژیم غذایی متعادل و همه چیز خواری مختص فصول گرم">منو رژیم غذایی متعادل و همه چیز خواری گرم</option>
            <option value="منو رژیم غذایی متعادل و همه چیز خواری مختص فصول سرد">منو رژیم غذایی متعادل و همه چیز خواری سرد</option>
          </Input>
        </FormGroup>
      </Col>
      <Col md="6">
        <FormGroup>
          <Label style={labelStyle}>کپی برای وعده‌های دیگر (اختیاری)</Label>
          <Input
            type="select"
            name="additionalMeals"
            value={formData.additionalMeals}
            onChange={handleInputChange}
            style={multiSelectStyle}
            multiple
            onFocus={(e) => e.target.style.borderColor = "#f472b6"}
            onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
          >
            <option value="صبحانه">صبحانه</option>
            <option value="بعد از صبحانه">بعد از صبحانه</option>
            <option value="میان‌وعده صبح">میان‌وعده صبح</option>
            <option value="ناهار">ناهار</option>
            <option value="بعد از ناهار">بعد از ناهار</option>
            <option value="میان‌وعده عصر">میان‌وعده عصر</option>
            <option value="شام">شام</option>
            <option value="بعد از شام">بعد از شام</option>
          </Input>
        </FormGroup>
      </Col>
    </Row>
  )}
  <div style={{ textAlign: "center", marginTop: "24px", display: "flex", justifyContent: "center", gap: "16px" }}>
    <Button
      style={{
        ...buttonStyle,
        background: "linear-gradient(45deg, #a855f7, #d8b4fe)",
      }}
      onClick={handleCopy}
      onMouseOver={(e) =>
        Object.assign(e.target.style, {
          background: "linear-gradient(45deg, #d8b4fe, #a855f7)",
          transform: "translateY(-2px)",
        })
      }
      onMouseOut={(e) =>
        Object.assign(e.target.style, {
          background: "linear-gradient(45deg, #a855f7, #d8b4fe)",
          transform: "none",
        })
      }
    >
      <i className="fas fa-copy" />
      کپی اطلاعات
    </Button>
    <Button
      style={{
        ...buttonStyle,
        background: "linear-gradient(45deg, #3b82f6, #60a5fa)",
        ...(copiedData ? {} : buttonDisabledStyle),
      }}
      onClick={handlePaste}
      disabled={!copiedData}
      onMouseOver={(e) =>
        copiedData &&
        Object.assign(e.target.style, {
          background: "linear-gradient(45deg, #60a5fa, #3b82f6)",
          transform: "translateY(-2px)",
        })
      }
      onMouseOut={(e) =>
        Object.assign(e.target.style, {
          background: "linear-gradient(45deg, #3b82f6, #60a5fa)",
          transform: "none",
        })
      }
    >
      <i className="fas fa-paste" />
      پیست اطلاعات
    </Button>
    <Button
      type="submit"
      style={{
        ...buttonStyle,
        background: "linear-gradient(45deg, #2dd4bf, #5eead4)",
      }}
      onMouseOver={(e) =>
        Object.assign(e.target.style, {
          background: "linear-gradient(45deg, #5eead4, #2dd4bf)",
          transform: "translateY(-2px)",
        })
      }
      onMouseOut={(e) =>
        Object.assign(e.target.style, {
          background: "linear-gradient(45deg, #2dd4bf, #5eead4)",
          transform: "none",
        })
      }
    >
      <i className="fas fa-check" />
      ثبت {formType === "menu" ? "منو" : "سهمیه"}
    </Button>
  </div>
                    </form>
                    </>
                  )}
                  {/* بخش فیلترها */}
                  <Card style={{
                    marginBottom: "24px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "12px",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)"
                  }}>
                    <CardHeader style={{
                      background: "#f9fafb",
                      borderBottom: "1px solid #e5e7eb",
                      padding: "16px 20px"
                    }}>
                      <h5 style={{ 
                        color: "#1f2937", 
                        margin: 0, 
                        fontSize: "1.1rem", 
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px"
                      }}>
                        <i className="fas fa-filter" style={{ color: "#6b7280" }} />
                        فیلترها و جستجو
                      </h5>
                    </CardHeader>
                    <CardBody style={{ padding: "20px" }}>
                      <Row>
                        <Col md="12" lg="4" style={{ marginBottom: "16px" }}>
                          <FormGroup>
                            <Label style={{ ...labelStyle, color: "#000000", fontWeight: "500", fontSize: "0.9rem" }}>جستجوی نام غذا</Label>
                            <Input
                              type="text"
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                              style={{
                                ...inputStyle,
                                background: "#ffffff",
                                border: "1px solid #d1d5db",
                                borderRadius: "8px",
                                padding: "10px 12px",
                                color: "#000000"
                              }}
                              placeholder="نام غذا را وارد کنید"
                              onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                              onBlur={(e) => e.target.style.borderColor = "#d1d5db"}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6" lg="3" style={{ marginBottom: "16px" }}>
                          <FormGroup>
                            <Label style={{ ...labelStyle, color: "#000000", fontWeight: "500", fontSize: "0.9rem" }}>فیلتر دسته</Label>
                            <Input
                              type="select"
                              value={filterCategory}
                              onChange={(e) => setFilterCategory(e.target.value)}
                              style={{
                                ...selectStyle,
                                background: "#ffffff",
                                border: "1px solid #d1d5db",
                                borderRadius: "8px",
                                padding: "10px 12px",
                                color: "#000000"
                              }}
                              onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                              onBlur={(e) => e.target.style.borderColor = "#d1d5db"}
                            >
                              <option value="" style={{ color: "#000000" }}>همه دسته‌ها</option>
                              <option value="منوی رژیم غذایی متعادل و همه چیز خواری تمام فصول" style={{ color: "#000000" }}>منوی رژیم غذایی متعادل و همه چیز خواری تمام فصول</option>
                              <option value="منو رژیم غذایی گیاه خواری همراه با شیر و تخم مرغ" style={{ color: "#000000" }}>منو رژیم غذایی گیاه خواری همراه با شیر و تخم مرغ</option>
                              <option value="منو رژیم غذایی پر پروتئین" style={{ color: "#000000" }}>منو رژیم غذایی پر پروتئین</option>
                              <option value="منو رژیم غذایی متعادل و همه چیز خواری مختص فصول گرم" style={{ color: "#000000" }}>منو رژیم غذایی متعادل و همه چیز خواری مختص فصول گرم</option>
                              <option value="منو رژیم غذایی متعادل و همه چیز خواری مختص فصول سرد" style={{ color: "#000000" }}>منو رژیم غذایی متعادل و همه چیز خواری مختص فصول سرد</option>
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="6" lg="3" style={{ marginBottom: "16px" }}>
                          <FormGroup>
                            <Label style={{ ...labelStyle, color: "#000000", fontWeight: "500", fontSize: "0.9rem" }}>فیلتر وعده</Label>
                            <Input
                              type="select"
                              value={filterMeal}
                              onChange={(e) => setFilterMeal(e.target.value)}
                              style={{
                                ...selectStyle,
                                background: "#ffffff",
                                border: "1px solid #d1d5db",
                                borderRadius: "8px",
                                padding: "10px 12px",
                                color: "#000000"
                              }}
                              onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                              onBlur={(e) => e.target.style.borderColor = "#d1d5db"}
                            >
                              <option value="" style={{ color: "#000000" }}>همه وعده‌ها</option>
                              <option value="صبحانه" style={{ color: "#000000" }}>صبحانه</option>
                              <option value="بعد از صبحانه" style={{ color: "#000000" }}>بعد از صبحانه</option>
                              <option value="میان‌وعده صبح" style={{ color: "#000000" }}>میان‌وعده صبح</option>
                              <option value="ناهار" style={{ color: "#000000" }}>ناهار</option>
                              <option value="بعد از ناهار" style={{ color: "#000000" }}>بعد از ناهار</option>
                              <option value="میان‌وعده عصر" style={{ color: "#000000" }}>میان‌وعده عصر</option>
                              <option value="شام" style={{ color: "#000000" }}>شام</option>
                              <option value="بعد از شام" style={{ color: "#000000" }}>بعد از شام</option>
                              <option value="خوراکی خوشمزه بعد از شام" style={{ color: "#000000" }}>خوراکی خوشمزه بعد از شام</option>
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="12" lg="2" style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", gap: "10px" }}>
                          <Button
                            style={{ 
                              ...buttonStyle, 
                              background: filterOver100 ? "#ef4444" : "#6b7280",
                              border: "none",
                              color: "white",
                              width: "100%",
                              marginBottom: "8px",
                              borderRadius: "8px",
                              padding: "10px",
                              fontWeight: "500"
                            }}
                            onClick={() => {
                              setFilterOver100(!filterOver100);
                              setPagination({ ...pagination, current_page: 1 });
                            }}
                            onMouseOver={(e) =>
                              Object.assign(e.target.style, {
                                background: filterOver100 ? "#dc2626" : "#4b5563",
                                transform: "translateY(-1px)",
                              })
                            }
                            onMouseOut={(e) =>
                              Object.assign(e.target.style, {
                                background: filterOver100 ? "#ef4444" : "#6b7280",
                                transform: "none",
                              })
                            }
                          >
                            <i className="fas fa-filter" />
                            {filterOver100 ? "لغو فیلتر 100%" : "بیشتر از 100%"}
                          </Button>
                          <Button
                            style={{ 
                              ...buttonStyle, 
                              background: filterWithoutGroup ? "#7c3aed" : "#8b5cf6",
                              border: "none",
                              color: "white",
                              width: "100%",
                              marginBottom: "8px",
                              borderRadius: "8px",
                              padding: "10px",
                              fontWeight: "500"
                            }}
                            onClick={async () => {
                              const newFilterValue = !filterWithoutGroup;
                              setFilterWithoutGroup(newFilterValue);
                              setPagination({ ...pagination, current_page: 1 });
                              setIsFilteringWithoutGroup(true);
                              try {
                                await fetchMenuList(1, true, newFilterValue);
                              } finally {
                                setIsFilteringWithoutGroup(false);
                              }
                            }}
                            disabled={isFilteringWithoutGroup || isLoading}
                            onMouseOver={(e) => {
                              if (!isFilteringWithoutGroup && !isLoading) {
                                Object.assign(e.target.style, {
                                  background: filterWithoutGroup ? "#6d28d9" : "#7c3aed",
                                  transform: "translateY(-1px)",
                                });
                              }
                            }}
                            onMouseOut={(e) => {
                              if (!isFilteringWithoutGroup && !isLoading) {
                                Object.assign(e.target.style, {
                                  background: filterWithoutGroup ? "#7c3aed" : "#8b5cf6",
                                  transform: "none",
                                });
                              }
                            }}
                          >
                            {isFilteringWithoutGroup ? (
                              "در حال بارگذاری..."
                            ) : filterWithoutGroup ? (
                              <>
                                <i className="fas fa-times-circle" />
                                لغو فیلتر بدون گروه
                              </>
                            ) : (
                              <>
                                <i className="fas fa-ban" />
                                منوهای بدون گروه
                              </>
                            )}
                          </Button>
                          <Button
                            style={{ 
                              ...buttonStyle, 
                              background: "#ffffff",
                              border: "1px solid #d1d5db",
                              color: "#374151",
                              width: "100%",
                              borderRadius: "8px",
                              padding: "10px",
                              fontWeight: "500"
                            }}
                            onClick={handleResetFilters}
                            onMouseOver={(e) => Object.assign(e.target.style, { 
                              background: "#f9fafb",
                              borderColor: "#9ca3af",
                              transform: "translateY(-1px)" 
                            })}
                            onMouseOut={(e) => Object.assign(e.target.style, { 
                              background: "#ffffff",
                              borderColor: "#d1d5db",
                              transform: "none" 
                            })}
                          >
                            <i className="fas fa-undo" />
                            ریست فیلترها
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  {/* بخش دکمه‌های مدیریت گروه‌ها */}
                  <Card style={{
                    marginBottom: "24px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "12px",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)"
                  }}>
                    <CardHeader style={{
                      background: "#f9fafb",
                      borderBottom: "1px solid #e5e7eb",
                      padding: "16px 20px"
                    }}>
                      <h5 style={{ 
                        color: "#1f2937", 
                        margin: 0, 
                        fontSize: "1.1rem", 
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px"
                      }}>
                        <i className="fas fa-layer-group" style={{ color: "#6b7280" }} />
                        مدیریت گروه‌ها
                      </h5>
                    </CardHeader>
                    <CardBody style={{ padding: "20px" }}>
                      <Row>
                        <Col md="6" lg="4" style={{ marginBottom: "12px" }}>
                          <Button
                            style={{
                              ...buttonStyle,
                              background: "#3b82f6",
                              border: "none",
                              color: "white",
                              width: "100%",
                              fontWeight: "500",
                              borderRadius: "8px",
                              padding: "12px"
                            }}
                            onClick={async () => {
                              setShowManageGroupsModal(true);
                              await fetchGroupsWithMenus();
                            }}
                            disabled={isLoadingGroupsList}
                            onMouseOver={(e) => !isLoadingGroupsList && Object.assign(e.target.style, { 
                              background: "#2563eb",
                              transform: "translateY(-1px)",
                              boxShadow: "0 2px 4px rgba(59, 130, 246, 0.3)"
                            })}
                            onMouseOut={(e) => Object.assign(e.target.style, { 
                              background: "#3b82f6",
                              transform: "none",
                              boxShadow: "none"
                            })}
                          >
                            <i className="fas fa-list" style={{ marginLeft: "8px" }} />
                            مدیریت گروه‌ها
                          </Button>
                        </Col>
                        <Col md="6" lg="4" style={{ marginBottom: "12px" }}>
                          <Button
                            style={{
                              ...buttonStyle,
                              background: "#ef4444",
                              border: "none",
                              color: "white",
                              width: "100%",
                              fontWeight: "500",
                              borderRadius: "8px",
                              padding: "12px"
                            }}
                            onClick={async () => {
                              setShowResetGroupsModal(true);
                              await fetchMenusWithGroups();
                            }}
                            disabled={isLoadingGroups}
                            onMouseOver={(e) => !isLoadingGroups && Object.assign(e.target.style, { 
                              background: "#dc2626",
                              transform: "translateY(-1px)",
                              boxShadow: "0 2px 4px rgba(239, 68, 68, 0.3)"
                            })}
                            onMouseOut={(e) => Object.assign(e.target.style, { 
                              background: "#ef4444",
                              transform: "none",
                              boxShadow: "none"
                            })}
                          >
                            <i className="fas fa-undo" style={{ marginLeft: "8px" }} />
                            ریست همه گروه‌ها
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                  <Modal
  isOpen={showEditModal}
  toggle={() => setShowEditModal(false)}
  style={modalStyle}
  backdrop="static"
  keyboard={false}
>
  <ModalHeader
    toggle={() => setShowEditModal(false)}
    style={{
      background: "#1e2a44",
      color: "#e2e8f0",
      borderBottom: "1px solid rgba(255, 255, 255, 0.15)",
    }}
  >
    ویرایش {formType === "menu" ? "منو" : "سهمیه"}
  </ModalHeader>
  <ModalBody style={{ background: "#1e2a44" }}>
    <form onSubmit={handleEditSubmit}>
      {/* دکمه‌های انتخاب نوع فرم */}
      <div
        style={{
          marginBottom: "16px",
          display: "flex",
          gap: "8px",
          justifyContent: "center",
        }}
      >
        <Button
          style={{
            ...buttonStyle,
            background:
              formType === "menu"
                ? "linear-gradient(45deg, #f472b6, #f9a8d4)"
                : "linear-gradient(45deg, #6b7280, #4b5563)",
          }}
          onClick={() => {
            setFormType("menu");
            setFormData({
              ...formData,
              category: formData.category || "", // حفظ یا تنظیم مقدار پیش‌فرض
              meal: formData.meal || "",
              diet_type: formData.diet_type || "",
              text: formData.text || "",
            });
            setFoldNappes(foldNappes.length > 0 ? foldNappes : []); // حفظ سفره‌چین‌ها
          }}
          onMouseOver={(e) =>
            Object.assign(e.target.style, {
              background:
                formType === "menu"
                  ? "linear-gradient(45deg, #f9a8d4, #f472b6)"
                  : "linear-gradient(45deg, #4b5563, #6b7280)",
              transform: "translateY(-2px)",
            })
          }
          onMouseOut={(e) =>
            Object.assign(e.target.style, {
              background:
                formType === "menu"
                  ? "linear-gradient(45deg, #f472b6, #f9a8d4)"
                  : "linear-gradient(45deg, #6b7280, #4b5563)",
              transform: "none",
            })
          }
        >
          منو
        </Button>
        <Button
          style={{
            ...buttonStyle,
            background:
              formType === "portion"
                ? "linear-gradient(45deg, #f472b6, #f9a8d4)"
                : "linear-gradient(45deg, #6b7280, #4b5563)",
          }}
          onClick={() => {
            setFormType("portion");
            setFormData({
              ...formData,
              category: "", // خالی کردن فیلدهای خاص منو
              meal: "",
              diet_type: "",
              text: "",
            });
            setFoldNappes([]); // حذف سفره‌چین‌ها در حالت سهمیه
          }}
          onMouseOver={(e) =>
            Object.assign(e.target.style, {
              background:
                formType === "portion"
                  ? "linear-gradient(45deg, #f9a8d4, #f472b6)"
                  : "linear-gradient(45deg, #4b5563, #6b7280)",
              transform: "translateY(-2px)",
            })
          }
          onMouseOut={(e) =>
            Object.assign(e.target.style, {
              background:
                formType === "portion"
                  ? "linear-gradient(45deg, #f472b6, #f9a8d4)"
                  : "linear-gradient(45deg, #6b7280, #4b5563)",
              transform: "none",
            })
          }
        >
          سهمیه
        </Button>
      </div>

      {/* آیتم‌ها */}
      {items.map((item, index) => (
        <Row key={item.id} style={{ marginBottom: "16px", alignItems: "center" }}>
          <Col md="3">
            <FormGroup>
              <Label style={labelStyle}>
                آیتم {["اول", "دوم", "سوم", "چهارم", "پنجم"][index]}
              </Label>
              <Input
                type="text"
                value={item.name}
                onChange={(e) => handleItemChange(item.id, "name", e.target.value)}
                style={inputStyle}
                placeholder={`نام آیتم ${["اول", "دوم", "سوم", "چهارم", "پنجم"][index]}`}
                required
                onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
                onBlur={(e) =>
                  (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
                }
              />
            </FormGroup>
          </Col>
          <Col md="2">
            <FormGroup>
              <Label style={labelStyle}>کالری</Label>
              <Input
                type="number"
                value={item.calories}
                onChange={(e) => handleItemChange(item.id, "calories", e.target.value)}
                style={inputStyle}
                placeholder="کالری"
                min="0"
                step="0.1"
                required
                onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
                onBlur={(e) =>
                  (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
                }
              />
            </FormGroup>
          </Col>
          <Col md="2">
            <FormGroup>
              <Label style={labelStyle}>درصد</Label>
              <Input
                type="number"
                value={item.percentage}
                onChange={(e) =>
                  handleItemChange(item.id, "percentage", e.target.value)
                }
                style={inputStyle}
                placeholder="درصد"
                min="0"
                max="100"
                required
                onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
                onBlur={(e) =>
                  (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
                }
              />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <Label style={labelStyle}>نوع گرد کردن</Label>
              <Input
                type="select"
                value={item.rounding_method}
                onChange={(e) =>
                  handleItemChange(item.id, "rounding_method", e.target.value)
                }
                style={inputStyle}
                required
                onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
                onBlur={(e) =>
                  (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
                }
              >
                <option value="round_half">گرد به ۰.۵</option>
                <option value="round_5g">گرد به ۵ گرم</option>
                <option value="round_quarter">گرد به یک‌چهارم</option>
                <option value="round_full">گرد کردن واحد کامل</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md="2" style={{ display: "flex", alignItems: "center" }}>
            {items.length > 1 && (
              <Button
                color="danger"
                size="sm"
                onClick={() => removeItem(item.id)}
                style={{ padding: "8px", borderRadius: "6px" }}
              >
                <i className="fas fa-trash" />
              </Button>
            )}
          </Col>
        </Row>
      ))}
      <Button
        style={{
          ...buttonStyle,
          background: "linear-gradient(45deg, #38a169, #48bb78)",
          ...(items.length >= 5 ? buttonDisabledStyle : {}),
        }}
        onClick={addItem}
        disabled={items.length >= 5}
        onMouseOver={(e) =>
          items.length < 5 &&
          Object.assign(e.target.style, {
            background: "linear-gradient(45deg, #48bb78, #38a169)",
            transform: "translateY(-2px)",
          })
        }
        onMouseOut={(e) =>
          Object.assign(e.target.style, {
            background: "linear-gradient(45deg, #38a169, #48bb78)",
            transform: "none",
          })
        }
      >
        <i className="fas fa-plus-circle" />
        افزودن آیتم جدید
      </Button>

      {/* سفره‌چین‌ها - فقط برای منو */}
      {formType === "menu" &&
        foldNappes.length > 0 &&
        foldNappes.map((fold, index) => (
          <Row
            key={fold.id}
            style={{ marginBottom: "16px", alignItems: "center", marginTop: "16px" }}
          >
            <Col md="2">
              <FormGroup>
                <Label style={labelStyle}>
                  سفره‌چین {["اول", "دوم", "سوم", "چهارم", "پنجم"][index]}
                </Label>
                <Input
                  type="text"
                  value={fold.name}
                  onChange={(e) =>
                    handleFoldNappeChange(fold.id, "name", e.target.value)
                  }
                  style={inputStyle}
                  placeholder={`اسم سفره‌چین ${["اول", "دوم", "سوم", "چهارم", "پنجم"][index]}`}
                  required
                  onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
                  onBlur={(e) =>
                    (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
                  }
                />
              </FormGroup>
            </Col>
            <Col md="2">
              <FormGroup>
                <Label style={labelStyle}>نحوه چیدمان</Label>
                <Input
                  type="text"
                  value={fold.arrangement}
                  onChange={(e) =>
                    handleFoldNappeChange(fold.id, "arrangement", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="مثال: $عدد خرما"
                  required
                  onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
                  onBlur={(e) =>
                    (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
                  }
                />
              </FormGroup>
            </Col>
            <Col md="2">
              <FormGroup>
                <Label style={labelStyle}>درصد</Label>
                <Input
                  type="number"
                  value={fold.percentage}
                  disabled
                  style={inputStyle}
                  placeholder="درصد"
                  onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
                  onBlur={(e) =>
                    (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
                  }
                />
              </FormGroup>
            </Col>
            <Col md="2">
              <FormGroup>
                <Label style={labelStyle}>کالری</Label>
                <Input
                  type="number"
                  value={fold.calories}
                  onChange={(e) =>
                    handleFoldNappeChange(fold.id, "calories", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="کالری"
                  min="0"
                  step="0.1"
                  required
                  onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
                  onBlur={(e) =>
                    (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
                  }
                />
              </FormGroup>
            </Col>
            <Col md="2">
              <FormGroup>
                <Label style={labelStyle}>نوع گرد کردن</Label>
                <Input
                  type="select"
                  value={fold.rounding_method}
                  onChange={(e) =>
                    handleFoldNappeChange(fold.id, "rounding_method", e.target.value)
                  }
                  style={inputStyle}
                  required
                  onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
                  onBlur={(e) =>
                    (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
                  }
                >
                  <option value="round_half">گرد به ۰.۵</option>
                  <option value="round_5g">گرد به ۵ گرم</option>
                  <option value="round_quarter">گرد به یک‌چهارم</option>
                  <option value="round_full">گرد کردن واحد کامل</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md="2" style={{ display: "flex", alignItems: "center" }}>
              <Button
                color="danger"
                size="sm"
                onClick={() => removeFoldNappe(fold.id)}
                style={{ padding: "8px", borderRadius: "6px" }}
              >
                <i className="fas fa-trash" />
              </Button>
            </Col>
          </Row>
        ))}
      {formType === "menu" && (
        <Button
          style={{
            ...buttonStyle,
            background: "linear-gradient(45deg, #38a169, #48bb78)",
            ...(foldNappes.length >= 5 ? buttonDisabledStyle : {}),
          }}
          onClick={addFoldNappe}
          disabled={foldNappes.length >= 5}
          onMouseOver={(e) =>
            foldNappes.length < 5 &&
            Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #48bb78, #38a169)",
              transform: "translateY(-2px)",
            })
          }
          onMouseOut={(e) =>
            Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #38a169, #48bb78)",
              transform: "none",
            })
          }
        >
          <i className="fas fa-plus-circle" />
          افزودن سفره‌چین جدید
        </Button>
      )}

      {/* فیلدهای فرم */}
      <Row style={{ marginBottom: "16px", marginTop: "16px" }}>
        <Col md="6">
          <FormGroup>
            <Label style={labelStyle}>اسم {formType === "menu" ? "غذا" : "سهمیه"}</Label>
            <Input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              style={inputStyle}
              placeholder={`اسم ${formType === "menu" ? "غذا" : "سهمیه"}`}
              required
              onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
              onBlur={(e) =>
                (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
              }
            />
          </FormGroup>
        </Col>
        {formType === "portion" && (
    <Col md="6">
      <FormGroup>
        <Label style={labelStyle}>نوع سهمیه</Label>
        <Input
          type="select"
          name="portion_type"
          value={formData.portion_type}
          onChange={handleInputChange}
          style={selectStyle}
          required
          onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
          onBlur={(e) => (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")}
        >
          <option value="">یک نوع سهمیه انتخاب کنید</option>
          <option value="سهمیه لبنیات">سهمیه لبنیات</option>
          <option value="سهمیه روغن زیتون">سهمیه روغن زیتون</option>
          <option value="سهمیه قند">سهمیه قند</option>
          <option value="سهمیه آجیل">سهمیه آجیل</option>
        </Input>
      </FormGroup>
    </Col>
  )}

{formType === "portion" && (
  <Col md="6">
  <FormGroup>
    <Label style={labelStyle}>نحوه چیدمان سهمیه</Label>
    <Input
      type="textarea"
      name="text"
      value={formData.text}
      onChange={handleInputChange}
      style={{ ...inputStyle, height: "80px", resize: "none" }}
      placeholder="مقداری که سیستم به دست میاره با $ نشان دهید مثال : $عدد شیر+$عدد خرما"
      onFocus={(e) => e.target.style.borderColor = "#f472b6"}
      onBlur={(e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.2)"}
    />
  </FormGroup>
  </Col>
)}
        {formType === "menu" && (
          <Col md="6">
            <FormGroup>
              <Label style={labelStyle}>دسته</Label>
              <Input
                type="select"
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                style={selectStyle}
                required
                onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
                onBlur={(e) =>
                  (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
                }
              >
                <option value="">یک دسته انتخاب کنید</option>
                <option value="منوی رژیم غذایی متعادل و همه چیز خواری تمام فصول">
                  منوی رژیم غذایی متعادل و همه چیز خواری تمام فصول
                </option>
                <option value="منو رژیم غذایی گیاه خواری همراه با شیر و تخم مرغ">
                  منو رژیم غذایی گیاه خواری همراه با شیر و تخم مرغ
                </option>
                <option value="منو رژیم غذایی پر پروتئین">
                  منو رژیم غذایی پر پروتئین
                </option>
                <option value="منو رژیم غذایی متعادل و همه چیز خواری مختص فصول گرم">
                  منو رژیم غذایی متعادل و همه چیز خواری گرم
                </option>
                <option value="منو رژیم غذایی متعادل و همه چیز خواری مختص فصول سرد">
                  منو رژیم غذایی متعادل و همه چیز خواری سرد
                </option>
              </Input>
            </FormGroup>
          </Col>
        )}
      </Row>
      {formType === "menu" && (
        <Row style={{ marginBottom: "16px" }}>
          <Col md="6">
            <FormGroup>
              <Label style={labelStyle}>وعده</Label>
              <Input
                type="select"
                name="meal"
                value={formData.meal}
                onChange={handleInputChange}
                style={selectStyle}
                required
                onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
                onBlur={(e) =>
                  (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
                }
              >
                <option value="">یک وعده انتخاب کنید</option>
                <option value="صبحانه">صبحانه</option>
                <option value="بعد از صبحانه">بعد از صبحانه</option>
                <option value="میان‌وعده صبح">میان‌وعده صبح</option>
                <option value="ناهار">ناهار</option>
                <option value="بعد از ناهار">بعد از ناهار</option>
                <option value="میان‌وعده عصر">میان‌وعده عصر</option>
                <option value="شام">شام</option>
                <option value="بعد از شام">بعد از شام</option>
                <option value="خوراکی خوشمزه بعد از شام">خوراکی خوشمزه بعد از شام</option>
              </Input>
            </FormGroup>
          </Col>
          {/* <Col md="6">
            <FormGroup>
              <Label style={labelStyle}>نوع رژیم</Label>
              <Input
                type="select"
                name="diet_type"
                value={formData.diet_type}
                onChange={handleInputChange}
                style={selectStyle}
                onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
                onBlur={(e) =>
                  (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
                }
              >
                <option value="">مشترک</option>
                <option value="weight_loss">رژیم کاهش وزن</option>
                <option value="weight_gain">رژیم افزایش وزن</option>
                <option value="weight_maintenance">رژیم ثبات وزن</option>
              </Input>
            </FormGroup>
          </Col> */}
        </Row>
      )}
      {formType === "menu" && (
        <FormGroup>
          <Label style={labelStyle}>نحوه چیدمان منو</Label>
          <Input
            type="textarea"
            name="text"
            value={formData.text}
            onChange={handleInputChange}
            style={{ ...inputStyle, height: "80px", resize: "none" }}
            placeholder="مقداری که سیستم به دست میاره با $ نشان دهید مثال : $عدد کیک+$عدد شیر"
            onFocus={(e) => (e.target.style.borderColor = "#f472b6")}
            onBlur={(e) =>
              (e.target.style.borderColor = "rgba(255, 255, 255, 0.2)")
            }
          />
        </FormGroup>
      )}

      <ModalFooter
        style={{
          background: "#1e2a44",
          borderTop: "1px solid rgba(255, 255, 255, 0.15)",
          display: "flex",
          gap: "16px",
        }}
      >
        <Button
          style={{
            ...buttonStyle,
            background: "linear-gradient(45deg, #a855f7, #d8b4fe)",
          }}
          onClick={handleCopy}
          onMouseOver={(e) =>
            Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #d8b4fe, #a855f7)",
              transform: "translateY(-2px)",
            })
          }
          onMouseOut={(e) =>
            Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #a855f7, #d8b4fe)",
              transform: "none",
            })
          }
        >
          <i className="fas fa-copy" />
          کپی اطلاعات
        </Button>
        <Button
          style={{
            ...buttonStyle,
            background: "linear-gradient(45deg, #3b82f6, #60a5fa)",
            ...(copiedData ? {} : buttonDisabledStyle),
          }}
          onClick={handlePaste}
          disabled={!copiedData}
          onMouseOver={(e) =>
            copiedData &&
            Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #60a5fa, #3b82f6)",
              transform: "translateY(-2px)",
            })
          }
          onMouseOut={(e) =>
            Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #3b82f6, #60a5fa)",
              transform: "none",
            })
          }
        >
          <i className="fas fa-paste" />
          پیست اطلاعات
        </Button>
        <Button
          color="secondary"
          onClick={() => setShowEditModal(false)}
          style={{
            ...buttonStyle,
            background: "linear-gradient(45deg, #6b7280, #4b5563)",
          }}
          onMouseOver={(e) =>
            Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #4b5563, #6b7280)",
              transform: "translateY(-2px)",
            })
          }
          onMouseOut={(e) =>
            Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #6b7280, #4b5563)",
              transform: "none",
            })
          }
        >
          لغو
        </Button>
        <Button
          type="submit"
          style={{
            ...buttonStyle,
            background: "linear-gradient(45deg, #2dd4bf, #5eead4)",
          }}
          onMouseOver={(e) =>
            Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #5eead4, #2dd4bf)",
              transform: "translateY(-2px)",
            })
          }
          onMouseOut={(e) =>
            Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #2dd4bf, #5eead4)",
              transform: "none",
            })
          }
        >
          <i className="fas fa-check" />
          ثبت تغییرات
        </Button>
      </ModalFooter>
    </form>
  </ModalBody>
                  </Modal>
                  {/* دکمه‌های گروه‌بندی دسته‌ای */}
                  <div style={{ 
                    marginBottom: "16px", 
                    padding: "12px", 
                    background: selectedMenusForBulkGroup.length > 0 
                      ? "linear-gradient(45deg, #3b82f6, #60a5fa)" 
                      : "rgba(255, 255, 255, 0.05)",
                    borderRadius: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: selectedMenusForBulkGroup.length > 0 ? "none" : "1px solid rgba(255, 255, 255, 0.1)"
                  }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      {selectedMenusForBulkGroup.length > 0 ? (
                        <span style={{ color: "white", fontWeight: "600", fontSize: "0.9rem" }}>
                          {selectedMenusForBulkGroup.length} منو انتخاب شده است
                        </span>
                      ) : (
                        <>
                          {(searchQuery || filterCategory || filterMeal) && (
                            <Button
                              style={{
                                ...buttonStyle,
                                background: "linear-gradient(45deg, #8b5cf6, #a78bfa)",
                                color: "white",
                                fontSize: "0.85rem",
                                padding: "8px 16px"
                              }}
                              onClick={handleSelectAllSearchResults}
                              disabled={isLoading}
                            >
                              <i className="fas fa-check-double" style={{ marginLeft: "6px" }} />
                              انتخاب همه نتایج جستجو ({pagination.total} منو)
                            </Button>
                          )}
                        </>
                      )}
                    </div>
                    {selectedMenusForBulkGroup.length > 0 && (
                      <div style={{ display: "flex", gap: "8px" }}>
                        <Button
                          style={{
                            ...buttonStyle,
                            background: "linear-gradient(45deg, #10b981, #34d399)",
                            color: "white"
                          }}
                          onClick={() => setShowBulkGroupModal(true)}
                        >
                          <i className="fas fa-users" style={{ marginLeft: "8px" }} />
                          گروه‌بندی دسته‌ای
                        </Button>
                        <Button
                          style={{
                            ...buttonStyle,
                            background: "linear-gradient(45deg, #6b7280, #4b5563)",
                            color: "white"
                          }}
                          onClick={() => setSelectedMenusForBulkGroup([])}
                        >
                          <i className="fas fa-times" style={{ marginLeft: "8px" }} />
                          لغو انتخاب
                        </Button>
                      </div>
                    )}
                  </div>
                  <div style={tableContainerStyle}>
                    <Table style={tableStyle}>
                      <thead style={tableHeaderStyle}>
                        <tr>
                          <th style={tableCellStyle}>
                            <input
                              type="checkbox"
                              checked={
                                pagination.total > 0 && 
                                selectedMenusForBulkGroup.length > 0 &&
                                selectedMenusForBulkGroup.length === pagination.total &&
                                menuList.every(menu => selectedMenusForBulkGroup.includes(menu.id))
                              }
                              onChange={handleSelectAll}
                              style={checkboxStyle}
                              title="انتخاب همه نتایج (تمام صفحات)"
                            />
                            <br />
                            <small style={{ fontSize: "0.7rem", color: "#9ca3af", display: "block", marginTop: "4px" }}>
                              همه ({pagination.total})
                            </small>
                          </th>
                          <th style={tableCellStyle}>#</th>
                          <th style={tableCellStyle}>عملیات</th>
                          <th style={tableCellStyle}>انتخاب غذا</th>
                          <th style={tableCellStyle}>تخصیص گروه</th>
                          <th style={tableCellStyle}>عنوان گروه</th>
                          <th style={tableCellStyle}>شماره گروه</th>
                          <th style={tableCellStyle}>تکرار هفتگی</th>
                          <th style={tableCellStyle}>نام غذا</th>
                          <th style={tableCellStyle}>دسته</th>
                          <th style={tableCellStyle}>وعده</th>
                          <th style={tableCellStyle}>آیتم‌ها</th>
                          <th style={tableCellStyle}>سفره‌چین‌ها</th>
                          <th style={tableCellStyle}>نحوه چیدمان</th>
                          <th style={tableCellStyle}>نوع فرم</th>
                          
                          
                        </tr>
                      </thead>
                      <tbody>
                        {menuList.length > 0 ? (
                          menuList.map((menu, index) => (
                            <tr key={menu.id} style={tableRowStyle}>
                              <td style={tableCellStyle}>
                                <input
                                  type="checkbox"
                                  checked={selectedMenusForBulkGroup.includes(menu.id)}
                                  onChange={() => handleMenuSelection(menu.id)}
                                  style={checkboxStyle}
                                />
                              </td>
                              <td style={tableCellStyle}>{(pagination.current_page - 1) * pagination.per_page + index + 1}</td>
                              <td style={tableCellStyle}>
                                <Button
                                  color="warning"
                                  size="sm"
                                  onClick={() => handleEdit(menu)}
                                  style={{ margin: "0 4px", padding: "8px", borderRadius: "6px" }}
                                >
                                  <i className="fas fa-edit" />
                                </Button>
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() => handleDelete(menu.id)}
                                  style={{ margin: "0 4px", padding: "8px", borderRadius: "6px" }}
                                >
                                  <i className="fas fa-trash" />
                                </Button>
                              </td>
                              <td style={tableCellStyle}>
                                <input
                                  type="checkbox"
                                  checked={isFoodSelected[menu.id] || false}
                                  onChange={() => handleFoodSelection(menu.id, menu.name)}
                                  style={checkboxStyle}
                                />
                              </td>
                              <td style={tableCellStyle}>
    <Button
      style={{
        ...buttonStyle,
        background: "linear-gradient(45deg, #f0abfc, #f9d3ff)",
        padding: "8px",
        borderRadius: "8px"
      }}
      onClick={() => {
        // اگر غذا قبلاً گروه داشته باشد، فیلدها را با مقادیر موجود پر کن
        if (menu.group_number) {
          setSelectedGroup(menu.group_number.toString());
        } else {
          setSelectedGroup("");
        }
        if (menu.group_title) {
          setGroupTitle(menu.group_title);
        } else {
          setGroupTitle("");
        }
        if (menu.group_repetition_count) {
          setGroupRepetitionCount(menu.group_repetition_count.toString());
        } else {
          setGroupRepetitionCount("");
        }
        setShowGroupModal(menu.id);
      }}
      onMouseOver={(e) => Object.assign(e.target.style, {
        background: "linear-gradient(45deg, #f9d3ff, #f0abfc)",
        transform: "translateY(-2px)"
      })}
      onMouseOut={(e) => Object.assign(e.target.style, {
        background: "linear-gradient(45deg, #f0abfc, #f9d3ff)",
        transform: "none"
      })}
    >
      <i className="fas fa-users" />
    </Button>
    <Modal
  isOpen={showGroupModal === menu.id}
  toggle={() => setShowGroupModal(null)}
  style={groupModalStyle}
  backdrop="static"
  keyboard={false}
>
  <ModalHeader
    toggle={() => setShowGroupModal(null)}
    style={{
      background: "#f8fafc",
      color: "#1f2937",
      borderBottom: "1px solid #e5e7eb",
      fontFamily: "'Dana', sans-serif"
    }}
  >
    تخصیص گروه
  </ModalHeader>
  <ModalBody style={{ background: "#f8fafc", textAlign: "center", padding: "24px" }}>
    <FormGroup>
      <Label style={{ ...labelStyle, background: "none", WebkitTextFillColor: "#1f2937" }}>عنوان گروه</Label>
      <Input
        type="text"
        value={groupTitle}
        onChange={(e) => setGroupTitle(e.target.value)}
        style={groupInputStyle}
        placeholder="عنوان گروه"
        onFocus={(e) => e.target.style.borderColor = "#a5b4fc"}
        onBlur={(e) => e.target.style.borderColor = "#cbd5e1"}
      />
    </FormGroup>
    <FormGroup>
      <Label style={{ ...labelStyle, background: "none", WebkitTextFillColor: "#1f2937" }}>شماره گروه</Label>
      <Input
        type="text"
        value={selectedGroup}
        onChange={(e) => setSelectedGroup(e.target.value)}
        style={groupInputStyle}
        placeholder="شماره گروه"
        onFocus={(e) => e.target.style.borderColor = "#a5b4fc"}
        onBlur={(e) => e.target.style.borderColor = "#cbd5e1"}
      />
    </FormGroup>
    <FormGroup>
      <Label style={{ ...labelStyle, background: "none", WebkitTextFillColor: "#1f2937" }}>تعداد تکرار در هفته (اختیاری)</Label>
      <Input
        type="number"
        min="1"
        max="7"
        value={groupRepetitionCount}
        onChange={(e) => {
          const value = e.target.value;
          // فقط اعداد بین 1 تا 7 را قبول کن
          if (value === "" || (parseInt(value) >= 1 && parseInt(value) <= 7)) {
            setGroupRepetitionCount(value);
          }
        }}
        style={groupInputStyle}
        placeholder="مثلاً 2 (برای 2 بار در هفته)"
        onFocus={(e) => e.target.style.borderColor = "#a5b4fc"}
        onBlur={(e) => e.target.style.borderColor = "#cbd5e1"}
      />
      <small style={{ color: "#6b7280", fontSize: "0.75rem", marginTop: "4px", display: "block" }}>
        تعداد دفعاتی که این گروه در هفته باید استفاده شود (1 تا 7)
      </small>
    </FormGroup>
    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "8px" }}>
      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
        <Button
          key={number}
          style={{
            ...numberButtonStyle,
            ...(selectedGroup.includes(number.toString()) ? numberButtonActiveStyle : {})
          }}
          onClick={() => setSelectedGroup((prev) => prev + number.toString())}
          onMouseOver={(e) => Object.assign(e.target.style, numberButtonHoverStyle)}
          onMouseOut={(e) => Object.assign(e.target.style, {
            background: selectedGroup.includes(number.toString())
              ? "linear-gradient(45deg, #a5b4fc, #c7d2fe)"
              : "linear-gradient(45deg, #e2e8f0, #f1f5f9)",
            transform: "none",
            boxShadow: "none"
          })}
        >
          {number}
        </Button>
      ))}
    </div>
  </ModalBody>
  <ModalFooter
    style={{
      background: "#f8fafc",
      borderTop: "1px solid #e5e7eb",
      justifyContent: "center",
      padding: "16px"
    }}
  >
    <Button
      style={{
        ...buttonStyle,
        background: "linear-gradient(45deg, #a5b4fc, #c7d2fe)",
        ...(selectedGroup === "" || groupTitle === "" ? buttonDisabledStyle : {})
      }}
      onClick={() => {
        if (selectedGroup !== "" && groupTitle !== "") {
          assignGroupToMenu(menu.id, selectedGroup, groupTitle, groupRepetitionCount);
          setShowGroupModal(null);
          setSelectedGroup("");
          setGroupTitle("");
          setGroupRepetitionCount("");
        }
      }}
      disabled={selectedGroup === "" || groupTitle === ""}
      onMouseOver={(e) => selectedGroup !== "" && groupTitle !== "" && Object.assign(e.target.style, {
        background: "linear-gradient(45deg, #c7d2fe, #a5b4fc)",
        transform: "translateY(-2px)"
      })}
      onMouseOut={(e) => Object.assign(e.target.style, {
        background: "linear-gradient(45deg, #a5b4fc, #c7d2fe)",
        transform: "none"
      })}
    >
      <i className="fas fa-check" />
      تایید
    </Button>
    <Button
      style={{
        ...buttonStyle,
        background: "linear-gradient(45deg, #d1d5db, #e5e7eb)"
      }}
      onClick={() => {
        setShowGroupModal(null);
        setSelectedGroup("");
        setGroupTitle("");
        setGroupRepetitionCount("");
      }}
      onMouseOver={(e) => Object.assign(e.target.style, {
        background: "linear-gradient(45deg, #e5e7eb, #d1d5db)",
        transform: "translateY(-2px)"
      })}
      onMouseOut={(e) => Object.assign(e.target.style, {
        background: "linear-gradient(45deg, #d1d5db, #e5e7eb)",
        transform: "none"
      })}
    >
      لغو
    </Button>
  </ModalFooter>
    </Modal>
                                </td>
                              <td style={tableCellStyle}>{menu.group_title}</td>
                              <td style={tableCellStyle}>{menu.group_number}</td>
                              <td style={tableCellStyle}>
                                {menu.group_repetition_count ? (
                                  <span style={{ 
                                    background: "linear-gradient(45deg, #10b981, #34d399)", 
                                    color: "white", 
                                    padding: "4px 12px", 
                                    borderRadius: "6px",
                                    fontSize: "0.85rem",
                                    fontWeight: "600"
                                  }}>
                                    {menu.group_repetition_count} بار
                                  </span>
                                ) : (
                                  <span style={{ color: "#9ca3af" }}>-</span>
                                )}
                              </td>
                              <td style={tableCellStyle}>{menu.name}</td>
                              <td style={tableCellStyle}>{menu.category}</td>
                              <td style={tableCellStyle}>{menu.meal}</td>
                             
                              <td style={tableCellStyle}>
                                {menu.items.map((item, i) => (
                                  <div key={i}>
                                    {item.name} ({item.percentage}% - {item.calories} کالری - {roundingMethodLabels[item.rounding_method]})
                                  </div>
                                ))}
                              </td>
                              <td style={tableCellStyle}>
                                {menu.fold_nappes.length > 0 ? (
                                  menu.fold_nappes.map((fold, i) => (
                                    <div key={i} style={{ marginBottom: "4px" }}>
                                      <input
                                        type="checkbox"
                                        checked={selectedFoldNappes[menu.id] === fold.name}
                                        onChange={() => handleFoldNappeSelection(menu.id, fold.name)}
                                        style={checkboxStyle}
                                      /> {fold.name} ({Math.floor(fold.percentage)}% - {fold.calories} کالری - {fold.arrangement} - {roundingMethodLabels[fold.rounding_method]})
                                    </div>
                                  ))
                                ) : (
                                  <span>-</span>
                                )}
                              </td>
                              <td style={tableCellStyle}>{menu.text || '-'}</td>
                              <td style={tableCellStyle}>
              {menu.form_type === "menu" ? "منو" : "سهمیه"} {/* نمایش نوع فرم */}
                               </td>
                              
                            
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" style={{ ...tableCellStyle, textAlign: "center" }}>
                              هیچ منویی یافت نشد.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                  {pagination.total > pagination.per_page && (
                    <div style={paginationStyle}>
                      <Button
                        style={{
                          ...pageButtonStyle,
                          ...(pagination.current_page === 1 ? pageButtonDisabledStyle : {})
                        }}
                        onClick={() => handlePageChange(pagination.current_page - 1)}
                        disabled={pagination.current_page === 1}
                        onMouseOver={(e) => pagination.current_page !== 1 && Object.assign(e.target.style, pageButtonHoverStyle)}
                        onMouseOut={(e) => Object.assign(e.target.style, { background: "linear-gradient(45deg, #4b5563, #6b7280)", transform: "none" })}
                      >
                        قبلی
                      </Button>
                      {renderPagination().map((button, index) => (
                        <Button
                          key={index}
                          style={{
                            ...pageButtonStyle,
                            ...(button.disabled && !button.page ? pageButtonDisabledStyle : {}),
                            ...(pagination.current_page === button.page ? pageButtonActiveStyle : {})
                          }}
                          onClick={() => button.page && handlePageChange(button.page)}
                          disabled={button.disabled}
                          onMouseOver={(e) => !button.disabled && Object.assign(e.target.style, pageButtonHoverStyle)}
                          onMouseOut={(e) => Object.assign(e.target.style, {
                            background: pagination.current_page === button.page 
                              ? "linear-gradient(45deg, #f472b6, #f9a8d4)"
                              : "linear-gradient(45deg, #4b5563, #6b7280)",
                            transform: "none"
                          })}
                        >
                          {button.label}
                        </Button>
                      ))}
                      <Button
                        style={{
                          ...pageButtonStyle,
                          ...(pagination.current_page === pagination.last_page ? pageButtonDisabledStyle : {})
                        }}
                        onClick={() => handlePageChange(pagination.current_page + 1)}
                        disabled={pagination.current_page === pagination.last_page}
                        onMouseOver={(e) => pagination.current_page !== pagination.last_page && Object.assign(e.target.style, pageButtonHoverStyle)}
                        onMouseOut={(e) => Object.assign(e.target.style, { background: "linear-gradient(45deg, #4b5563, #6b7280)", transform: "none" })}
                      >
                        بعدی
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </div>

      {/* مدال گروه‌بندی دسته‌ای */}
      <Modal
        isOpen={showBulkGroupModal}
        toggle={() => {
          setShowBulkGroupModal(false);
          setBulkGroupNumber("");
          setBulkGroupTitle("");
          setBulkGroupRepetitionCount("");
        }}
        style={{
          ...groupModalStyle,
          maxWidth: "95vw",
          width: "95vw",
          height: "95vh",
          margin: "2.5vh auto"
        }}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <ModalHeader
          toggle={() => {
            setShowBulkGroupModal(false);
            setBulkGroupNumber("");
            setBulkGroupTitle("");
            setBulkGroupRepetitionCount("");
          }}
          style={{
            background: "#f8fafc",
            color: "#1f2937",
            borderBottom: "1px solid #e5e7eb",
            fontFamily: "'Dana', sans-serif"
          }}
        >
          گروه‌بندی دسته‌ای ({selectedMenusForBulkGroup.length} منو)
        </ModalHeader>
        <ModalBody style={{ background: "#f8fafc", padding: "24px", maxHeight: "85vh", overflowY: "auto" }}>
          <div style={{ marginBottom: "16px", padding: "12px", background: "#e0f2fe", borderRadius: "8px", color: "#0369a1", textAlign: "right" }}>
            <i className="fas fa-info-circle" style={{ marginLeft: "8px" }} />
            شما در حال گروه‌بندی {selectedMenusForBulkGroup.length} منو هستید. تمام این منوها به یک گروه اختصاص داده می‌شوند.
          </div>

          {/* نمایش گروه‌های موجود */}
          {existingGroups.length > 0 && (
            <div style={{ marginBottom: "24px", padding: "16px", background: "#fef3c7", borderRadius: "8px", border: "1px solid #fbbf24" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                <Label style={{ color: "#92400e", fontWeight: "700", fontSize: "1rem", marginBottom: "0" }}>
                  <i className="fas fa-layer-group" style={{ marginLeft: "8px" }} />
                  گروه‌های موجود ({existingGroups.length}):
                </Label>
                <Button
                  size="sm"
                  style={{
                    background: "linear-gradient(45deg, #f59e0b, #fbbf24)",
                    border: "none",
                    borderRadius: "6px",
                    padding: "4px 12px",
                    color: "white",
                    fontSize: "0.8rem"
                  }}
                  onClick={fetchExistingGroups}
                  disabled={isLoadingExistingGroups}
                >
                  <i className={`fas ${isLoadingExistingGroups ? 'fa-spinner fa-spin' : 'fa-sync-alt'}`} style={{ marginLeft: "6px" }} />
                  به‌روزرسانی
                </Button>
              </div>
              <div style={{ 
                display: "flex", 
                flexWrap: "wrap", 
                gap: "8px",
                maxHeight: "200px",
                overflowY: "auto"
              }}>
                {existingGroups.map((group, index) => (
                  <Button
                    key={`${group.group_number}_${group.group_title}`}
                    style={{
                      background: "linear-gradient(45deg, #10b981, #34d399)",
                      border: "none",
                      borderRadius: "8px",
                      padding: "10px 16px",
                      color: "white",
                      fontSize: "0.9rem",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                    }}
                    onClick={() => assignMenusToExistingGroup(group.group_number, group.group_title, group.group_repetition_count)}
                    disabled={isLoading}
                    onMouseOver={(e) => {
                      if (!isLoading) {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
                      }
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = "none";
                      e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                    }}
                  >
                    <i className="fas fa-users" style={{ marginLeft: "8px" }} />
                    گروه {group.group_number}: {group.group_title}
                    {group.group_repetition_count && (
                      <span style={{ marginRight: "4px", fontSize: "0.85rem", opacity: 0.9 }}>
                        ({group.group_repetition_count} بار/هفته)
                      </span>
                    )}
                    <span style={{ marginRight: "8px", fontSize: "0.8rem", opacity: 0.8 }}>
                      ({group.menu_count} منو)
                    </span>
                  </Button>
                ))}
              </div>
              <div style={{ marginTop: "12px", padding: "8px", background: "#fef3c7", borderRadius: "6px", fontSize: "0.85rem", color: "#92400e", textAlign: "right" }}>
                <i className="fas fa-mouse-pointer" style={{ marginLeft: "6px" }} />
                برای تخصیص منوهای انتخاب شده به یک گروه موجود، روی آن کلیک کنید
              </div>
            </div>
          )}

          {isLoadingExistingGroups && existingGroups.length === 0 && (
            <div style={{ marginBottom: "24px", padding: "16px", textAlign: "center", color: "#6b7280" }}>
              <i className="fas fa-spinner fa-spin" style={{ marginLeft: "8px" }} />
              در حال بارگذاری گروه‌های موجود...
            </div>
          )}

          {!isLoadingExistingGroups && existingGroups.length === 0 && (
            <div style={{ marginBottom: "24px", padding: "12px", background: "#f3f4f6", borderRadius: "8px", color: "#6b7280", textAlign: "right", fontSize: "0.9rem" }}>
              <i className="fas fa-info-circle" style={{ marginLeft: "8px" }} />
              هیچ گروهی موجود نیست. می‌توانید یک گروه جدید ایجاد کنید.
            </div>
          )}

          <div style={{ marginBottom: "16px", padding: "12px", background: "#ede9fe", borderRadius: "8px", color: "#5b21b6", textAlign: "right", fontSize: "0.9rem", fontWeight: "600" }}>
            <i className="fas fa-plus-circle" style={{ marginLeft: "8px" }} />
            یا یک گروه جدید ایجاد کنید:
          </div>
          
          <Row>
            <Col md="6">
              <FormGroup>
                <Label style={{ ...labelStyle, background: "none", WebkitTextFillColor: "#1f2937" }}>عنوان گروه</Label>
                <Input
                  type="text"
                  value={bulkGroupTitle}
                  onChange={(e) => setBulkGroupTitle(e.target.value)}
                  style={groupInputStyle}
                  placeholder="مثلاً: برنج‌ها"
                  onFocus={(e) => e.target.style.borderColor = "#a5b4fc"}
                  onBlur={(e) => e.target.style.borderColor = "#cbd5e1"}
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label style={{ ...labelStyle, background: "none", WebkitTextFillColor: "#1f2937" }}>شماره گروه</Label>
                <Input
                  type="text"
                  value={bulkGroupNumber}
                  onChange={(e) => setBulkGroupNumber(e.target.value)}
                  style={groupInputStyle}
                  placeholder="شماره گروه"
                  onFocus={(e) => e.target.style.borderColor = "#a5b4fc"}
                  onBlur={(e) => e.target.style.borderColor = "#cbd5e1"}
                />
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "8px", marginTop: "12px" }}>
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
                    <Button
                      key={number}
                      style={{
                        ...numberButtonStyle,
                        ...(bulkGroupNumber.includes(number.toString()) ? numberButtonActiveStyle : {})
                      }}
                      onClick={() => setBulkGroupNumber((prev) => prev + number.toString())}
                      onMouseOver={(e) => Object.assign(e.target.style, numberButtonHoverStyle)}
                      onMouseOut={(e) => Object.assign(e.target.style, {
                        background: bulkGroupNumber.includes(number.toString())
                          ? "linear-gradient(45deg, #a5b4fc, #c7d2fe)"
                          : "linear-gradient(45deg, #e2e8f0, #f1f5f9)",
                        transform: "none",
                        boxShadow: "none"
                      })}
                    >
                      {number}
                    </Button>
                  ))}
                </div>
              </FormGroup>
            </Col>
          </Row>
          
          <FormGroup>
            <Label style={{ ...labelStyle, background: "none", WebkitTextFillColor: "#1f2937" }}>تعداد تکرار در هفته (اختیاری)</Label>
            <Input
              type="number"
              min="1"
              max="7"
              value={bulkGroupRepetitionCount}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || (parseInt(value) >= 1 && parseInt(value) <= 7)) {
                  setBulkGroupRepetitionCount(value);
                }
              }}
              style={{ ...groupInputStyle, maxWidth: "300px" }}
              placeholder="مثلاً 2 (برای 2 بار در هفته)"
              onFocus={(e) => e.target.style.borderColor = "#a5b4fc"}
              onBlur={(e) => e.target.style.borderColor = "#cbd5e1"}
            />
            <small style={{ color: "#6b7280", fontSize: "0.75rem", marginTop: "4px", display: "block" }}>
              تعداد دفعاتی که این گروه در هفته باید استفاده شود (1 تا 7)
            </small>
          </FormGroup>

          {/* نمایش منوهای بدون تیک انتخاب غذا */}
          {(() => {
            const unselectedMenus = selectedMenusData.filter(menu => 
              !menu.selected_food || 
              menu.selected_food === null || 
              menu.selected_food === undefined ||
              (typeof menu.selected_food === "string" && menu.selected_food.trim().length === 0)
            );
            
            if (unselectedMenus.length === 0) {
              return null;
            }
            
            return (
              <div style={{ marginTop: "24px", marginBottom: "24px", padding: "16px", background: "#fef2f2", borderRadius: "8px", border: "2px solid #f87171" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="fas fa-exclamation-triangle" style={{ color: "#dc2626", fontSize: "1.2rem" }} />
                    <Label style={{ color: "#991b1b", fontWeight: "700", fontSize: "1rem", marginBottom: "0" }}>
                      منوهای بدون تیک انتخاب غذا ({unselectedMenus.length} منو)
                    </Label>
                  </div>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <Button
                      size="sm"
                      style={{
                        background: "linear-gradient(45deg, #10b981, #34d399)",
                        border: "none",
                        borderRadius: "6px",
                        padding: "6px 12px",
                        color: "white",
                        fontSize: "0.8rem",
                        fontWeight: "600"
                      }}
                      onClick={handleSelectAllUnselectedMenus}
                      disabled={isLoading}
                    >
                      <i className="fas fa-check-double" style={{ marginLeft: "6px" }} />
                      انتخاب همگی
                    </Button>
                    <Button
                      size="sm"
                      style={{
                        background: "linear-gradient(45deg, #ef4444, #f87171)",
                        border: "none",
                        borderRadius: "6px",
                        padding: "6px 12px",
                        color: "white",
                        fontSize: "0.8rem",
                        fontWeight: "600"
                      }}
                      onClick={handleRemoveAllUnselectedMenus}
                      disabled={isLoading}
                    >
                      <i className="fas fa-trash-alt" style={{ marginLeft: "6px" }} />
                      حذف همگی
                    </Button>
                  </div>
                </div>
                <div style={{ 
                  padding: "12px", 
                  background: "#fee2e2", 
                  borderRadius: "6px", 
                  marginBottom: "12px",
                  color: "#991b1b",
                  fontSize: "0.9rem",
                  textAlign: "right"
                }}>
                  <i className="fas fa-info-circle" style={{ marginLeft: "6px" }} />
                  این منوها نمی‌توانند در گروه قرار بگیرند. لطفاً آن‌ها را انتخاب کنید یا از لیست حذف کنید.
                </div>
                <div style={{ 
                  maxHeight: "40vh", 
                  overflowY: "auto", 
                  border: "1px solid #fca5a5", 
                  borderRadius: "8px", 
                  padding: "12px",
                  background: "white"
                }}>
                  <Table style={{ marginBottom: 0, color: "#1f2937", background: "white" }}>
                    <thead>
                      <tr style={{ color: "#1f2937", background: "#fee2e2" }}>
                        <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#991b1b", textAlign: "right", background: "#fee2e2" }}>نام منو</th>
                        <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#991b1b", textAlign: "right", background: "#fee2e2" }}>وعده</th>
                        <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#991b1b", textAlign: "right", background: "#fee2e2" }}>دسته</th>
                        <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#991b1b", textAlign: "center", background: "#fee2e2" }}>عملیات</th>
                      </tr>
                    </thead>
                    <tbody style={{ color: "#1f2937", background: "white" }}>
                      {unselectedMenus.map((menu) => (
                        <tr key={menu.id} style={{ borderBottom: "1px solid #fca5a5", color: "#1f2937", background: "white" }}>
                          <td style={{ padding: "8px", fontSize: "0.85rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                            <span style={{ color: "#1f2937", fontWeight: "600" }}>{menu.name}</span>
                          </td>
                          <td style={{ padding: "8px", fontSize: "0.85rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                            <span style={{ color: "#1f2937" }}>{menu.meal}</span>
                          </td>
                          <td style={{ padding: "8px", fontSize: "0.85rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                            <span style={{ color: "#1f2937" }}>{menu.category}</span>
                          </td>
                          <td style={{ padding: "8px", textAlign: "center", color: "#1f2937", background: "white" }}>
                            <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
                              <Button
                                size="sm"
                                style={{
                                  background: "linear-gradient(45deg, #10b981, #34d399)",
                                  border: "none",
                                  borderRadius: "6px",
                                  padding: "4px 8px",
                                  color: "white",
                                  fontSize: "0.75rem"
                                }}
                                onClick={() => handleSelectFoodInBulkModal(menu.id, menu.name)}
                                disabled={isLoading}
                                title="انتخاب منو"
                              >
                                <i className="fas fa-check" />
                              </Button>
                              <Button
                                size="sm"
                                style={{
                                  background: "linear-gradient(45deg, #ef4444, #f87171)",
                                  border: "none",
                                  borderRadius: "6px",
                                  padding: "4px 8px",
                                  color: "white",
                                  fontSize: "0.75rem"
                                }}
                                onClick={() => handleRemoveMenuFromBulkSelection(menu.id)}
                                disabled={isLoading}
                                title="حذف از لیست"
                              >
                                <i className="fas fa-times" />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            );
          })()}

          {/* نمایش لیست منوهای انتخاب شده با امکان حذف */}
          <div style={{ marginTop: "24px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
              <Label style={{ ...labelStyle, background: "none", WebkitTextFillColor: "#1f2937", marginBottom: "0" }}>
                منوهای انتخاب شده ({selectedMenusForBulkGroup.length}):
              </Label>
              <Button
                size="sm"
                style={{
                  ...buttonStyle,
                  background: "linear-gradient(45deg, #ef4444, #f87171)",
                  color: "white",
                  padding: "6px 12px",
                  fontSize: "0.8rem"
                }}
                onClick={() => {
                  setSelectedMenusForBulkGroup([]);
                  setSelectedMenusData([]);
                }}
              >
                <i className="fas fa-times" style={{ marginLeft: "6px" }} />
                حذف همه
              </Button>
            </div>
            <div style={{ 
              maxHeight: "50vh", 
              overflowY: "auto", 
              border: "1px solid #e5e7eb", 
              borderRadius: "8px", 
              padding: "12px",
              background: "white"
            }}>
              {selectedMenusData.length > 0 ? (
                <Table style={{ marginBottom: 0, color: "#1f2937", background: "white" }}>
                  <thead>
                    <tr style={{ color: "#1f2937", background: "#f8fafc" }}>
                      <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>نام منو</th>
                      <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>وعده</th>
                      <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>دسته</th>
                      <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#1f2937", textAlign: "center", background: "#f8fafc" }}>عملیات</th>
                    </tr>
                  </thead>
                  <tbody style={{ color: "#1f2937", background: "white" }}>
                    {selectedMenusData.map((menu) => (
                      <tr key={menu.id} style={{ borderBottom: "1px solid #e5e7eb", color: "#1f2937", background: "white" }}>
                        <td style={{ padding: "8px", fontSize: "0.85rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                          <span style={{ color: "#1f2937", fontWeight: "600" }}>{menu.name}</span>
                        </td>
                        <td style={{ padding: "8px", fontSize: "0.85rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                          <span style={{ color: "#1f2937" }}>{menu.meal}</span>
                        </td>
                        <td style={{ padding: "8px", fontSize: "0.85rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                          <span style={{ color: "#1f2937" }}>{menu.category}</span>
                        </td>
                        <td style={{ padding: "8px", textAlign: "center", color: "#1f2937", background: "white" }}>
                          <Button
                            size="sm"
                            style={{
                              background: "linear-gradient(45deg, #ef4444, #f87171)",
                              border: "none",
                              borderRadius: "6px",
                              padding: "4px 8px",
                              color: "white",
                              fontSize: "0.75rem"
                            }}
                            onClick={() => handleMenuSelection(menu.id)}
                          >
                            <i className="fas fa-times" />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div style={{ padding: "20px", textAlign: "center", color: "#9ca3af" }}>
                  در حال بارگذاری اطلاعات منوها...
                </div>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter
          style={{
            background: "#f8fafc",
            borderTop: "1px solid #e5e7eb",
            justifyContent: "center",
            padding: "16px"
          }}
        >
          <Button
            style={{
              ...buttonStyle,
              background: "linear-gradient(45deg, #10b981, #34d399)",
              ...(bulkGroupNumber === "" || bulkGroupTitle === "" ? buttonDisabledStyle : {})
            }}
            onClick={handleBulkGroupAssignment}
            disabled={bulkGroupNumber === "" || bulkGroupTitle === "" || isLoading}
            onMouseOver={(e) => bulkGroupNumber !== "" && bulkGroupTitle !== "" && !isLoading && Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #34d399, #10b981)",
              transform: "translateY(-2px)"
            })}
            onMouseOut={(e) => Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #10b981, #34d399)",
              transform: "none"
            })}
          >
            <i className="fas fa-check" style={{ marginLeft: "8px" }} />
            تایید و اعمال به {selectedMenusForBulkGroup.length} منو
          </Button>
          <Button
            style={{
              ...buttonStyle,
              background: "linear-gradient(45deg, #d1d5db, #e5e7eb)"
            }}
            onClick={() => {
              setShowBulkGroupModal(false);
              setBulkGroupNumber("");
              setBulkGroupTitle("");
              setBulkGroupRepetitionCount("");
            }}
            onMouseOver={(e) => Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #e5e7eb, #d1d5db)",
              transform: "translateY(-2px)"
            })}
            onMouseOut={(e) => Object.assign(e.target.style, {
              background: "linear-gradient(45deg, #d1d5db, #e5e7eb)",
              transform: "none"
            })}
          >
            لغو
          </Button>
        </ModalFooter>
      </Modal>

      {/* مدال ریست همه گروه‌ها */}
      <Modal
        isOpen={showResetGroupsModal}
        toggle={() => {
          setShowResetGroupsModal(false);
          setMenusWithGroups([]);
        }}
        style={{
          maxWidth: "90vw",
          width: "90vw",
          height: "90vh",
          margin: "5vh auto"
        }}
        backdrop="static"
        keyboard={false}
        size="xl"
        contentClassName="custom-modal-content-reset"
        modalClassName="custom-modal-dialog-reset"
      >
        <ModalHeader
          toggle={() => {
            setShowResetGroupsModal(false);
            setMenusWithGroups([]);
          }}
          style={{
            background: "#f8fafc",
            color: "#1f2937",
            borderBottom: "1px solid #e5e7eb",
            fontFamily: "'Dana', sans-serif"
          }}
        >
          ریست همه گروه‌ها ({menusWithGroups.length} منو)
        </ModalHeader>
        <ModalBody style={{ background: "#f8fafc", padding: "24px", maxHeight: "75vh", overflowY: "auto" }}>
          {isLoadingGroups ? (
            <div style={{ padding: "40px", textAlign: "center" }}>
              <RingLoader color="#3b82f6" loading={true} size={50} />
              <p style={{ marginTop: "16px", color: "#6b7280" }}>در حال بارگذاری منوهای دارای گروه...</p>
            </div>
          ) : menusWithGroups.length > 0 ? (
            <div>
              <div style={{ marginBottom: "12px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Label style={{ ...labelStyle, background: "none", WebkitTextFillColor: "#1f2937", marginBottom: "0" }}>
                  منوهایی که گروه دارند:
                </Label>
                <span style={{ color: "#6b7280", fontSize: "0.9rem" }}>
                  مجموع: {menusWithGroups.length} منو
                </span>
              </div>
              <div style={{ 
                maxHeight: "60vh", 
                overflowY: "auto", 
                border: "1px solid #e5e7eb", 
                borderRadius: "8px", 
                padding: "12px",
                background: "white"
              }}>
                <Table style={{ marginBottom: 0, color: "#1f2937", background: "white" }}>
                  <thead>
                    <tr style={{ color: "#1f2937", background: "#f8fafc" }}>
                      <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>نام منو</th>
                      <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>عنوان گروه</th>
                      <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>شماره گروه</th>
                      <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>تکرار هفتگی</th>
                      <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>وعده</th>
                      <th style={{ padding: "8px", fontSize: "0.85rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>دسته</th>
                    </tr>
                  </thead>
                  <tbody style={{ color: "#1f2937", background: "white" }}>
                    {menusWithGroups.map((menu) => (
                      <tr key={menu.id} style={{ borderBottom: "1px solid #e5e7eb", color: "#1f2937", background: "white" }}>
                        <td style={{ padding: "8px", fontSize: "0.85rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                          <span style={{ color: "#1f2937", fontWeight: "600" }}>{menu.name}</span>
                        </td>
                        <td style={{ padding: "8px", fontSize: "0.85rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                          <span style={{ color: "#1f2937" }}>{menu.group_title || "-"}</span>
                        </td>
                        <td style={{ padding: "8px", fontSize: "0.85rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                          <span style={{ color: "#1f2937" }}>{menu.group_number || "-"}</span>
                        </td>
                        <td style={{ padding: "8px", fontSize: "0.85rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                          {menu.group_repetition_count ? (
                            <span style={{ 
                              background: "linear-gradient(45deg, #10b981, #34d399)", 
                              color: "white", 
                              padding: "4px 8px", 
                              borderRadius: "6px",
                              fontSize: "0.75rem",
                              fontWeight: "600"
                            }}>
                              {menu.group_repetition_count} بار
                            </span>
                          ) : (
                            <span style={{ color: "#9ca3af" }}>-</span>
                          )}
                        </td>
                        <td style={{ padding: "8px", fontSize: "0.85rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                          <span style={{ color: "#1f2937" }}>{menu.meal || "-"}</span>
                        </td>
                        <td style={{ padding: "8px", fontSize: "0.85rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                          <span style={{ color: "#1f2937" }}>{menu.category || "-"}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <div style={{ padding: "40px", textAlign: "center", color: "#6b7280" }}>
              <i className="fas fa-check-circle" style={{ fontSize: "3rem", color: "#10b981", marginBottom: "16px" }} />
              <p style={{ fontSize: "1.1rem" }}>هیچ منویی با گروه تخصیص داده شده وجود ندارد.</p>
            </div>
          )}
        </ModalBody>
        <ModalFooter
          style={{
            background: "#f8fafc",
            borderTop: "1px solid #e5e7eb",
            justifyContent: "center",
            padding: "16px"
          }}
        >
          {menusWithGroups.length > 0 && (
            <Button
              style={{
                ...buttonStyle,
                background: "linear-gradient(45deg, #ef4444, #f87171)",
              }}
              onClick={handleResetAllGroups}
              disabled={isLoading}
            >
              <i className="fas fa-trash" style={{ marginLeft: "8px" }} />
              تایید و ریست {menusWithGroups.length} منو
            </Button>
          )}
          <Button
            style={{
              ...buttonStyle,
              background: "linear-gradient(45deg, #d1d5db, #e5e7eb)"
            }}
            onClick={() => {
              setShowResetGroupsModal(false);
              setMenusWithGroups([]);
            }}
          >
            {menusWithGroups.length > 0 ? "لغو" : "بستن"}
          </Button>
        </ModalFooter>
      </Modal>

      {/* مدال مدیریت گروه‌ها */}
      <Modal
        isOpen={showManageGroupsModal}
        toggle={() => {
          setShowManageGroupsModal(false);
          setGroupsWithMenus([]);
          setExpandedGroups(new Set());
          setGroupSearchQuery("");
          setEditingRepetitionCount({});
        }}
        style={{
          maxWidth: "95vw",
          width: "95vw",
          height: "95vh",
          margin: "2.5vh auto"
        }}
        backdrop="static"
        keyboard={false}
        size="xl"
        contentClassName="custom-modal-content"
        modalClassName="custom-modal-dialog"
      >
        <ModalHeader
          toggle={() => {
            setShowManageGroupsModal(false);
            setGroupsWithMenus([]);
            setExpandedGroups(new Set());
            setGroupSearchQuery("");
            setEditingRepetitionCount({});
          }}
          style={{
            background: "#f8fafc",
            color: "#1f2937",
            borderBottom: "1px solid #e5e7eb",
            fontFamily: "'Dana', sans-serif",
            direction: "rtl",
            textAlign: "right"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <span>مدیریت گروه‌ها ({groupsWithMenus.length} گروه)</span>
          </div>
        </ModalHeader>
        <ModalBody style={{ background: "#f8fafc", padding: "24px", maxHeight: "85vh", overflowY: "auto", direction: "rtl" }}>
          {/* جستجوی گروه‌ها */}
          {groupsWithMenus.length > 0 && (
            <div style={{ marginBottom: "20px" }}>
              <FormGroup>
                <Label style={{ color: "#1f2937", fontWeight: "500", fontSize: "0.9rem", textAlign: "right" }}>
                  <i className="fas fa-search" style={{ marginLeft: "8px" }} />
                  جستجوی گروه
                </Label>
                <Input
                  type="text"
                  value={groupSearchQuery}
                  onChange={(e) => setGroupSearchQuery(e.target.value)}
                  placeholder="جستجو بر اساس شماره یا عنوان گروه..."
                  style={{
                    background: "#ffffff",
                    border: "1px solid #d1d5db",
                    borderRadius: "8px",
                    padding: "10px 12px",
                    color: "#000000",
                    textAlign: "right",
                    direction: "rtl"
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#3b82f6"}
                  onBlur={(e) => e.target.style.borderColor = "#d1d5db"}
                />
              </FormGroup>
            </div>
          )}
          
          {isLoadingGroupsList ? (
            <div style={{ padding: "40px", textAlign: "center" }}>
              <RingLoader color="#3b82f6" loading={true} size={50} />
              <p style={{ marginTop: "16px", color: "#6b7280" }}>در حال بارگذاری گروه‌ها...</p>
            </div>
          ) : (() => {
            // فیلتر کردن گروه‌ها بر اساس جستجو
            const filteredGroups = groupsWithMenus.filter(group => {
              if (!groupSearchQuery.trim()) return true;
              const searchLower = groupSearchQuery.toLowerCase();
              return (
                group.group_number.toString().includes(searchLower) ||
                group.group_title.toLowerCase().includes(searchLower)
              );
            });
            
            return filteredGroups.length > 0 ? (
              <div>
                {filteredGroups.map((group, groupIndex) => {
                const groupKey = `${group.group_number}_${group.group_title}`;
                const isExpanded = expandedGroups.has(groupKey);
                
                return (
                  <div 
                    key={groupKey}
                    style={{
                      marginBottom: "16px",
                      border: "1px solid #e5e7eb",
                      borderRadius: "12px",
                      background: "white",
                      overflow: "hidden",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)"
                    }}
                  >
                    {/* هدر گروه - قابل کلیک */}
                    <div 
                      style={{
                        background: isExpanded ? "#3b82f6" : "#6b7280",
                        color: "white",
                        padding: "16px 20px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                        transition: "background 0.2s"
                      }}
                      onClick={() => toggleGroupExpand(groupKey)}
                      onMouseOver={(e) => {
                        if (!isExpanded) {
                          e.currentTarget.style.background = "#4b5563";
                        }
                      }}
                      onMouseOut={(e) => {
                        if (!isExpanded) {
                          e.currentTarget.style.background = "#6b7280";
                        }
                      }}
                    >
                      <div style={{ flex: 1, display: "flex", alignItems: "center", gap: "12px", direction: "rtl", textAlign: "right" }}>
                        <i 
                          className={`fas fa-chevron-${isExpanded ? "down" : "left"}`}
                          style={{ 
                            fontSize: "0.9rem",
                            transition: "transform 0.2s",
                            transform: isExpanded ? "rotate(0deg)" : "rotate(90deg)"
                          }}
                        />
                        <div style={{ flex: 1, textAlign: "right" }}>
                          <h4 style={{ margin: 0, fontSize: "1.1rem", fontWeight: "700", color: "white", textAlign: "right" }}>
                            گروه {group.group_number}: {group.group_title}
                          </h4>
                          <div style={{ marginTop: "8px", fontSize: "0.85rem", opacity: 0.9, textAlign: "right", display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <i className="fas fa-repeat" style={{ marginLeft: "6px" }} />
                              <span>تکرار هفتگی:</span>
                              <Input
                                type="number"
                                min="1"
                                max="7"
                                value={editingRepetitionCount[groupKey] !== undefined 
                                  ? editingRepetitionCount[groupKey] 
                                  : (group.group_repetition_count || "")}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value === "" || (parseInt(value) >= 1 && parseInt(value) <= 7)) {
                                    setEditingRepetitionCount(prev => ({
                                      ...prev,
                                      [groupKey]: value === "" ? "" : value
                                    }));
                                  }
                                }}
                                onKeyPress={(e) => {
                                  if (e.key === "Enter") {
                                    e.target.blur();
                                  }
                                }}
                                style={{
                                  width: "60px",
                                  padding: "4px 8px",
                                  fontSize: "0.85rem",
                                  borderRadius: "4px",
                                  border: "1px solid rgba(255, 255, 255, 0.3)",
                                  background: "rgba(255, 255, 255, 0.2)",
                                  color: "white",
                                  textAlign: "center"
                                }}
                                placeholder="خالی"
                                disabled={isLoading}
                                onClick={(e) => e.stopPropagation()}
                                onFocus={(e) => {
                                  e.stopPropagation();
                                  e.target.style.background = "rgba(255, 255, 255, 0.3)";
                                  e.target.style.borderColor = "rgba(255, 255, 255, 0.5)";
                                }}
                                onBlur={(e) => {
                                  e.stopPropagation();
                                  e.target.style.background = "rgba(255, 255, 255, 0.2)";
                                  e.target.style.borderColor = "rgba(255, 255, 255, 0.3)";
                                  const currentValue = editingRepetitionCount[groupKey] !== undefined 
                                    ? editingRepetitionCount[groupKey] 
                                    : (group.group_repetition_count || "");
                                  const newValue = currentValue === "" ? null : parseInt(currentValue);
                                  if (newValue !== group.group_repetition_count) {
                                    updateGroupRepetitionCount(group.group_number, group.group_title, currentValue);
                                  }
                                }}
                              />
                              <span>بار</span>
                            </div>
                            <span style={{ marginRight: "8px", marginLeft: "8px" }}>|</span>
                            <span>
                              <i className="fas fa-utensils" style={{ marginLeft: "6px" }} />
                              {group.menus.length} منو
                            </span>
                          </div>
                        </div>
                      </div>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <Button
                          style={{
                            background: "rgba(255, 255, 255, 0.2)",
                            border: "1px solid rgba(255, 255, 255, 0.3)",
                            color: "white",
                            padding: "8px 16px",
                            borderRadius: "8px",
                            fontSize: "0.85rem",
                            fontWeight: "600",
                            cursor: "pointer"
                          }}
                          onClick={(e) => {
                            e.stopPropagation(); // جلوگیری از expand شدن
                            handleDeleteGroup(group.group_number, group.group_title);
                          }}
                          disabled={isLoading}
                          onMouseOver={(e) => !isLoading && Object.assign(e.target.style, {
                            background: "rgba(255, 255, 255, 0.3)"
                          })}
                          onMouseOut={(e) => Object.assign(e.target.style, {
                            background: "rgba(255, 255, 255, 0.2)"
                          })}
                        >
                          <i className="fas fa-trash" style={{ marginLeft: "6px" }} />
                          حذف گروه
                        </Button>
                      </div>
                    </div>

                    {/* لیست منوهای گروه - فقط وقتی expand شده باشد */}
                    {isExpanded && (
                      <div style={{ 
                        padding: "16px",
                        background: "#ffffff",
                        maxHeight: "60vh",
                        overflowY: "auto",
                        direction: "rtl"
                      }}>
                        {group.menus.length > 0 ? (
                          <Table style={{ marginBottom: 0, color: "#1f2937", background: "white", direction: "rtl" }}>
                            <thead>
                              <tr style={{ color: "#1f2937", background: "#f8fafc" }}>
                                <th style={{ padding: "10px", fontSize: "0.9rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>نام منو</th>
                                <th style={{ padding: "10px", fontSize: "0.9rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>وعده</th>
                                <th style={{ padding: "10px", fontSize: "0.9rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>دسته</th>
                                <th style={{ padding: "10px", fontSize: "0.9rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>عملیات</th>
                              </tr>
                            </thead>
                            <tbody style={{ color: "#1f2937", background: "white" }}>
                              {group.menus.map((menu) => (
                                <tr key={menu.id} style={{ borderBottom: "1px solid #e5e7eb", color: "#1f2937", background: "white" }}>
                                  <td style={{ padding: "10px", fontSize: "0.9rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                                    <span style={{ color: "#1f2937", fontWeight: "600" }}>{menu.name}</span>
                                  </td>
                                  <td style={{ padding: "10px", fontSize: "0.9rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                                    <span style={{ color: "#1f2937" }}>{menu.meal || "-"}</span>
                                  </td>
                                  <td style={{ padding: "10px", fontSize: "0.9rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                                    <span style={{ color: "#1f2937" }}>{menu.category || "-"}</span>
                                  </td>
                                  <td style={{ padding: "10px", fontSize: "0.9rem", textAlign: "right", background: "white" }}>
                                    <Button
                                      style={{
                                        background: "#ef4444",
                                        border: "none",
                                        color: "white",
                                        padding: "6px 12px",
                                        borderRadius: "6px",
                                        fontSize: "0.8rem",
                                        fontWeight: "600",
                                        cursor: "pointer"
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation(); // جلوگیری از expand/collapse شدن گروه
                                        handleRemoveMenuFromGroup(menu.id);
                                      }}
                                      onMouseOver={(e) => Object.assign(e.target.style, {
                                        background: "#dc2626",
                                        transform: "scale(1.05)"
                                      })}
                                      onMouseOut={(e) => Object.assign(e.target.style, {
                                        background: "#ef4444",
                                        transform: "scale(1)"
                                      })}
                                    >
                                      <i className="fas fa-times" style={{ marginRight: "4px" }} />
                                      حذف از گروه
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        ) : (
                          <div style={{ padding: "20px", textAlign: "center", color: "#6b7280" }}>
                            <p>این گروه منویی ندارد</p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
              </div>
            ) : (
              <div style={{ padding: "40px", textAlign: "center", color: "#6b7280" }}>
                <i className="fas fa-search" style={{ fontSize: "3rem", color: "#6b7280", marginBottom: "16px" }} />
                <p style={{ fontSize: "1.1rem" }}>هیچ گروهی با این جستجو یافت نشد.</p>
              </div>
            );
          })()}
        </ModalBody>
        <ModalFooter
          style={{
            background: "#f8fafc",
            borderTop: "1px solid #e5e7eb",
            justifyContent: "center",
            padding: "16px",
            direction: "rtl"
          }}
        >
          <Button
            style={{
              ...buttonStyle,
              background: "#6b7280",
              border: "none",
              color: "white",
              padding: "10px 24px",
              borderRadius: "8px",
              fontWeight: "500"
            }}
            onClick={() => {
              setShowManageGroupsModal(false);
              setGroupsWithMenus([]);
              setExpandedGroups(new Set());
              setGroupSearchQuery("");
            }}
            onMouseOver={(e) => Object.assign(e.target.style, {
              background: "#4b5563"
            })}
            onMouseOut={(e) => Object.assign(e.target.style, {
              background: "#6b7280"
            })}
          >
            بستن
          </Button>
        </ModalFooter>
      </Modal>

      {/* مدال نمایش منوهای بدون گروه */}
      <Modal
        isOpen={showMenusWithoutGroupModal}
        toggle={() => {
          setShowMenusWithoutGroupModal(false);
          setMenusWithoutGroup([]);
          setMenusWithoutGroupSearchQuery("");
        }}
        style={{
          maxWidth: "95vw",
          width: "95vw",
          height: "95vh",
          margin: "2.5vh auto"
        }}
        backdrop="static"
        keyboard={false}
        size="xl"
        contentClassName="custom-modal-content"
        modalClassName="custom-modal-dialog"
      >
        <ModalHeader
          toggle={() => {
            setShowMenusWithoutGroupModal(false);
            setMenusWithoutGroup([]);
            setMenusWithoutGroupSearchQuery("");
          }}
          style={{
            background: "#f8fafc",
            color: "#1f2937",
            borderBottom: "1px solid #e5e7eb",
            fontFamily: "'Dana', sans-serif",
            direction: "rtl",
            textAlign: "right"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <span>منوهای بدون گروه ({menusWithoutGroup.length} منو)</span>
          </div>
        </ModalHeader>
        <ModalBody style={{ background: "#f8fafc", padding: "24px", maxHeight: "85vh", overflowY: "auto", direction: "rtl" }}>
          {/* جستجوی منوها */}
          {menusWithoutGroup.length > 0 && (
            <div style={{ marginBottom: "20px" }}>
              <FormGroup>
                <Label style={{ color: "#1f2937", fontWeight: "500", fontSize: "0.9rem", textAlign: "right" }}>
                  <i className="fas fa-search" style={{ marginLeft: "8px" }} />
                  جستجوی منو
                </Label>
                <Input
                  type="text"
                  value={menusWithoutGroupSearchQuery}
                  onChange={(e) => setMenusWithoutGroupSearchQuery(e.target.value)}
                  placeholder="جستجو بر اساس نام، وعده یا دسته..."
                  style={{
                    borderRadius: "8px",
                    border: "1px solid #e5e7eb",
                    padding: "10px 16px",
                    fontSize: "0.9rem",
                    direction: "rtl",
                    textAlign: "right"
                  }}
                />
              </FormGroup>
            </div>
          )}

          {/* نمایش loading */}
          {isLoadingMenusWithoutGroup ? (
            <div style={{ padding: "40px", textAlign: "center" }}>
              <RingLoader color="#8b5cf6" loading={true} size={50} />
              <p style={{ marginTop: "16px", color: "#6b7280" }}>در حال بارگذاری منوهای بدون گروه...</p>
            </div>
          ) : menusWithoutGroup.length === 0 ? (
            <div style={{ padding: "40px", textAlign: "center", color: "#6b7280" }}>
              <i className="fas fa-check-circle" style={{ fontSize: "3rem", color: "#10b981", marginBottom: "16px" }} />
              <p style={{ fontSize: "1.1rem" }}>همه منوها دارای گروه هستند!</p>
            </div>
          ) : (() => {
            // فیلتر کردن منوها بر اساس جستجو
            const filteredMenus = menusWithoutGroup.filter(menu => {
              if (!menusWithoutGroupSearchQuery.trim()) return true;
              const searchLower = menusWithoutGroupSearchQuery.toLowerCase();
              return (
                (menu.name && menu.name.toLowerCase().includes(searchLower)) ||
                (menu.meal && menu.meal.toLowerCase().includes(searchLower)) ||
                (menu.category && menu.category.toLowerCase().includes(searchLower))
              );
            });
            
            return filteredMenus.length > 0 ? (
              <div>
                <div style={{ marginBottom: "16px", padding: "12px", background: "#ede9fe", borderRadius: "8px", color: "#5b21b6", textAlign: "right", fontSize: "0.9rem" }}>
                  <i className="fas fa-info-circle" style={{ marginLeft: "8px" }} />
                  {filteredMenus.length} منو بدون گروه یافت شد
                </div>
                <div style={{ 
                  maxHeight: "60vh", 
                  overflowY: "auto",
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  background: "white"
                }}>
                  <Table style={{ marginBottom: 0, color: "#1f2937", background: "white", direction: "rtl" }}>
                    <thead>
                      <tr style={{ color: "#1f2937", background: "#f8fafc" }}>
                        <th style={{ padding: "10px", fontSize: "0.9rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>نام منو</th>
                        <th style={{ padding: "10px", fontSize: "0.9rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>وعده</th>
                        <th style={{ padding: "10px", fontSize: "0.9rem", fontWeight: "700", color: "#1f2937", textAlign: "right", background: "#f8fafc" }}>دسته</th>
                      </tr>
                    </thead>
                    <tbody style={{ color: "#1f2937", background: "white" }}>
                      {filteredMenus.map((menu) => (
                        <tr key={menu.id} style={{ borderBottom: "1px solid #e5e7eb", color: "#1f2937", background: "white" }}>
                          <td style={{ padding: "10px", fontSize: "0.9rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                            <span style={{ color: "#1f2937", fontWeight: "600" }}>{menu.name || "-"}</span>
                          </td>
                          <td style={{ padding: "10px", fontSize: "0.9rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                            <span style={{ color: "#1f2937" }}>{menu.meal || "-"}</span>
                          </td>
                          <td style={{ padding: "10px", fontSize: "0.9rem", color: "#1f2937", textAlign: "right", background: "white" }}>
                            <span style={{ color: "#1f2937" }}>{menu.category || "-"}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <div style={{ padding: "40px", textAlign: "center", color: "#6b7280" }}>
                <i className="fas fa-search" style={{ fontSize: "3rem", color: "#6b7280", marginBottom: "16px" }} />
                <p style={{ fontSize: "1.1rem" }}>هیچ منویی با این جستجو یافت نشد.</p>
              </div>
            );
          })()}
        </ModalBody>
        <ModalFooter
          style={{
            background: "#f8fafc",
            borderTop: "1px solid #e5e7eb",
            justifyContent: "center",
            padding: "16px",
            direction: "rtl"
          }}
        >
          <Button
            style={{
              ...buttonStyle,
              background: "#6b7280",
              border: "none",
              color: "white",
              padding: "10px 24px",
              borderRadius: "8px",
              fontWeight: "500"
            }}
            onClick={() => {
              setShowMenusWithoutGroupModal(false);
              setMenusWithoutGroup([]);
              setMenusWithoutGroupSearchQuery("");
            }}
            onMouseOver={(e) => Object.assign(e.target.style, {
              background: "#4b5563"
            })}
            onMouseOut={(e) => Object.assign(e.target.style, {
              background: "#6b7280"
            })}
          >
            بستن
          </Button>
        </ModalFooter>
      </Modal>

      <style>{`
        .custom-modal-dialog {
          background: transparent !important;
        }
        .custom-modal-dialog .modal-content {
          background: #ffffff;
          border-radius: 12px;
          border: 1px solid #e5e7eb;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
        }
        .custom-modal-dialog-reset {
          background: transparent !important;
        }
        .custom-modal-dialog-reset .modal-content {
          background: #ffffff;
          border-radius: 12px;
          border: 1px solid #e5e7eb;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
        }
      `}</style>
    </>
  );
}

export default FoodList;